
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("g2oof", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $iHQDd = parcelRequire("iHQDd");


var $jiJCD = parcelRequire("jiJCD");


var $inPa6 = parcelRequire("inPa6");


var $lxDfD = parcelRequire("lxDfD");


var $1iSzD = parcelRequire("1iSzD");


var $iV5Ic = parcelRequire("iV5Ic");


var $lJlG6 = parcelRequire("lJlG6");


var $7mpOv = parcelRequire("7mpOv");


var $jmjWc = parcelRequire("jmjWc");


const $f23f475309e66803$export$9533f8bbe7f6f635 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "SZhro",
    name: "AIFloatingContextMenuLoadable",
    loader: async ()=>(await (parcelRequire("81QTc"))).AIFloatingContextMenu
});



var $cZa7r = parcelRequire("cZa7r");


var $a8ZQ3 = parcelRequire("a8ZQ3");


var $deZfn = parcelRequire("deZfn");


var $iVU5h = parcelRequire("iVU5h");


var $iSXh4 = parcelRequire("iSXh4");


var $cryCi = parcelRequire("cryCi");


var $fNzRA = parcelRequire("fNzRA");


var $4r9Ir = parcelRequire("4r9Ir");


var $7IghX = parcelRequire("7IghX");


var $9jl6v = parcelRequire("9jl6v");


var $8SCD6 = parcelRequire("8SCD6");


var $8i27m = parcelRequire("8i27m");


var $hd53J = parcelRequire("hd53J");


var $4L9ve = parcelRequire("4L9ve");


var $5fMeR = parcelRequire("5fMeR");


var $3mVfX = parcelRequire("3mVfX");


var $iNYtG = parcelRequire("iNYtG");


var $dJ5r4 = parcelRequire("dJ5r4");


var $fyPYm = parcelRequire("fyPYm");


var $5pQ1Y = parcelRequire("5pQ1Y");


var $jFm04 = parcelRequire("jFm04");


var $6pBXK = parcelRequire("6pBXK");





var $ep3mz = parcelRequire("ep3mz");


var $7QM6o = parcelRequire("7QM6o");


var $9sGCn = parcelRequire("9sGCn");


var $hSqtY = parcelRequire("hSqtY");


var $3IBnw = parcelRequire("3IBnw");


var $ln0hx = parcelRequire("ln0hx");


var $irVI7 = parcelRequire("irVI7");

/* Omnibar.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");





var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");


var $1Whri = parcelRequire("1Whri");


var $ccHMk = parcelRequire("ccHMk");

var $1qfLF = parcelRequire("1qfLF");


var $ghftu = parcelRequire("ghftu");


var $2AytZ = parcelRequire("2AytZ");


var $c6fYi = parcelRequire("c6fYi");


var $3gadb = parcelRequire("3gadb");


var $8unJx = parcelRequire("8unJx");


var $aOKRX = parcelRequire("aOKRX");


var $1eaCJ = parcelRequire("1eaCJ");





var $b0EGa = parcelRequire("b0EGa");


var $7W8i8 = parcelRequire("7W8i8");


var $1UApO = parcelRequire("1UApO");


var $17wUi = parcelRequire("17wUi");

/* OmnibarReactions.tsx generated by @compiled/babel-plugin v0.36.1 */ 













var $1s5hv = parcelRequire("1s5hv");


var $4FHTF = parcelRequire("4FHTF");


var $caX7N = parcelRequire("caX7N");


var $dTk3A = parcelRequire("dTk3A");


var $ibzAc = parcelRequire("ibzAc");


var $lsxnT = parcelRequire("lsxnT");


var $1NF8X = parcelRequire("1NF8X");


var $3FlVr = parcelRequire("3FlVr");


var $bQm3c = parcelRequire("bQm3c");


var $32x2E = parcelRequire("32x2E");




const $387c7e4b79a2c2e2$var$i18n = (0, $cgtv4.defineMessages)({
    thumbsUp: {
        id: "experiment-omnibar.omni-bar.reaction.thumbsUp",
        defaultMessage: "Thumbs up"
    },
    clap: {
        id: "experiment-omnibar.omni-bar.reaction.clap",
        defaultMessage: "Clap"
    },
    fire: {
        id: "experiment-omnibar.omni-bar.reaction.fire",
        defaultMessage: "Fire"
    },
    heart: {
        id: "experiment-omnibar.omni-bar.reaction.heart",
        defaultMessage: "Heart"
    },
    astonished: {
        id: "experiment-omnibar.omni-bar.reaction.astonished",
        defaultMessage: "Astonished"
    }
});
const $387c7e4b79a2c2e2$export$f15a7d7a553aca16 = [
    {
        id: '1f44d',
        shortName: ':thumbsup:',
        fallback: "\uD83D\uDC4D",
        tooltipDescriptor: $387c7e4b79a2c2e2$var$i18n.thumbsUp
    },
    {
        id: '1f44f',
        shortName: ':clap:',
        fallback: "\uD83D\uDC4F",
        tooltipDescriptor: $387c7e4b79a2c2e2$var$i18n.clap
    },
    {
        id: '1f525',
        shortName: ':fire:',
        fallback: "\uD83D\uDD25",
        tooltipDescriptor: $387c7e4b79a2c2e2$var$i18n.fire
    },
    {
        id: '2764',
        shortName: ':heart:',
        fallback: "\u2764\uFE0F",
        tooltipDescriptor: $387c7e4b79a2c2e2$var$i18n.heart
    },
    {
        id: '1f632',
        shortName: ':astonished:',
        fallback: "\uD83D\uDE32",
        tooltipDescriptor: $387c7e4b79a2c2e2$var$i18n.astonished
    }
];
const $387c7e4b79a2c2e2$export$56912a632457f516 = 20;
const $387c7e4b79a2c2e2$export$d78bee0d9fab78ad = 16;
const $387c7e4b79a2c2e2$export$d3cbd516c71e2528 = (shortName)=>{
    return $387c7e4b79a2c2e2$export$f15a7d7a553aca16.find((reaction)=>reaction.shortName === shortName);
};
const $387c7e4b79a2c2e2$export$12e0bba3487fb7fd = (emojiId)=>{
    const config = $387c7e4b79a2c2e2$export$f15a7d7a553aca16.find((r)=>r.id === emojiId);
    return config?.shortName ?? `:emoji-${emojiId}:`;
};
const $387c7e4b79a2c2e2$export$274f4038c85e9fe5 = (shortName)=>{
    return shortName.replace(/^:/, '').replace(/:$/, '').split('_').map((word)=>word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
};


/* DefaultReactionButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 











var $fVUfS = parcelRequire("fVUfS");











var $etuMO = parcelRequire("etuMO");


var $yuV6Z = parcelRequire("yuV6Z");





const $9773a79590870b2e$export$198be09030cc5890 = 'omnibar-bloom';
const $9773a79590870b2e$export$96c5409d0b98e3bf = (randomDrift, randomTilt, randomRotation, randomDistance)=>({
        animationName: $9773a79590870b2e$export$198be09030cc5890,
        bloomDrift: `${randomDrift}px`,
        bloomTilt: `${randomTilt}deg`,
        bloomRotation: `${randomRotation}deg`,
        bloomDistance: `${randomDistance}px`
    });


const $9db24e0dc1ddcbfa$export$673194083bf9485c = ()=>{
    const [animatingEmojis, setAnimatingEmojis] = (0, $42omo.useState)([]);
    const animationIdRef = (0, $42omo.useRef)(0);
    const animationTimersRef = (0, $42omo.useRef)(new Set());
    (0, $42omo.useEffect)(()=>{
        const timers = animationTimersRef.current;
        return ()=>{
            timers.forEach((timer)=>clearTimeout(timer));
            timers.clear();
        };
    }, []);
    const triggerBloomAnimation = (0, $42omo.useCallback)((x, y, emojiId)=>{
        const animation = (0, $9773a79590870b2e$export$96c5409d0b98e3bf)((Math.random() - 0.5) * 100, (Math.random() - 0.5) * 30, (Math.random() - 0.5) * 40, -120 - Math.random() * 80);
        const id = ++animationIdRef.current;
        setAnimatingEmojis((prev)=>[
                ...prev,
                {
                    id: id,
                    x: x,
                    y: y,
                    emojiId: emojiId,
                    ...animation
                }
            ]);
        const timer = setTimeout(()=>{
            animationTimersRef.current.delete(timer);
            setAnimatingEmojis((prev)=>prev.filter((e)=>e.id !== id));
        }, 1300);
        animationTimersRef.current.add(timer);
    }, []);
    return {
        animatingEmojis: animatingEmojis,
        triggerBloomAnimation: triggerBloomAnimation
    };
};


/* BloomAnimationEmoji.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @compiled/no-keyframes-tagged-template-expression, @atlaskit/design-system/no-keyframes-tagged-template-expression, @atlaskit/ui-styling-standard/no-unsafe-values */ 









const $806badad5c4e8903$var$bloomKeyframes = null;
const $806badad5c4e8903$var$styles = {
    bloomContainer: "_kqsw1n9t _t9ec1ooe _lcxvglyw _j7hqn20q _5sag1x5j _1pgl167c _1o51q7pw _1e0c1txw _4cvr1h6o _1bah1h6o"
};
const $806badad5c4e8903$var$BloomAnimationEmojiInner = ({ animatingEmoji: animatingEmoji, emojiProvider: emojiProvider, emojiSize: emojiSize = (0, $387c7e4b79a2c2e2$export$d78bee0d9fab78ad) })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $806badad5c4e8903$var$styles.bloomContainer,
        style: {
            left: `${animatingEmoji.x}px`,
            top: `${animatingEmoji.y}px`,
            '--bloom-drift': animatingEmoji.bloomDrift,
            '--bloom-tilt': animatingEmoji.bloomTilt,
            '--bloom-rotation': animatingEmoji.bloomRotation,
            '--bloom-distance': animatingEmoji.bloomDistance
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $etuMO.default), {
        emojiProvider: emojiProvider,
        emojiId: {
            id: animatingEmoji.emojiId,
            shortName: ''
        },
        showTooltip: false,
        fitToHeight: emojiSize
    }));
};
const $806badad5c4e8903$export$8f2cbc3d71d39c12 = /*#__PURE__*/ (0, $42omo.memo)($806badad5c4e8903$var$BloomAnimationEmojiInner);
$806badad5c4e8903$export$8f2cbc3d71d39c12.displayName = 'BloomAnimationEmoji';


const $12725042cedb1af2$var$OMNIBAR_ANALYTICS_SOURCE = 'confluenceOmniBar';
const $12725042cedb1af2$var$HOVER_TILT_MIN_DEG = -15;
const $12725042cedb1af2$var$HOVER_TILT_MAX_DEG = 15;
const $12725042cedb1af2$var$HOVER_LIFT_PX = 15;
const $12725042cedb1af2$var$HOVER_SCALE = 1.8;
function $12725042cedb1af2$var$getRandomHoverTilt() {
    return Math.floor(Math.random() * ($12725042cedb1af2$var$HOVER_TILT_MAX_DEG - $12725042cedb1af2$var$HOVER_TILT_MIN_DEG + 1)) + $12725042cedb1af2$var$HOVER_TILT_MIN_DEG;
}
const $12725042cedb1af2$var$styles = {
    emojiButton: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _19itglyw _2rko12b0 _1reoewfl _18m9ewfl _1rjc12x7 _18zr12x7 _1e0c1txw _4cvr1h6o _1bah1h6o _2hwxu2gc _1bsbzwfg _1ul9zwfg _4t3izwfg _1o9zidpf _lcxv1wug _bfhk1j28",
    emojiInnerContainer: "_1reoewfl _18m9ewfl _v5643kmg _1e0c1txw _4cvr1h6o _1bah1h6o _bfhk1j28 _1bsb1osq _4t3i1osq",
    tooltipTriggerWrapper: "_1reoewfl _18m9ewfl _1q51pxbi _1pfhmgjw _1e0c1o8l"
};
const $12725042cedb1af2$var$DefaultReactionButtonInner = ({ emojiId: emojiId, emojiProvider: emojiProvider, cloudId: cloudId, reacted: reacted, onClick: onClick, tooltipDescriptor: tooltipDescriptor })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { animatingEmojis: animatingEmojis, triggerBloomAnimation: triggerBloomAnimation } = (0, $9db24e0dc1ddcbfa$export$673194083bf9485c)();
    const [isTooltipVisible, setIsTooltipVisible] = (0, $42omo.useState)(true);
    const [isHovered, setIsHovered] = (0, $42omo.useState)(false);
    const [hoverTilt, setHoverTilt] = (0, $42omo.useState)(0);
    const emojiHoverTransform = isHovered ? `translateY(-${$12725042cedb1af2$var$HOVER_LIFT_PX}px) scale(${$12725042cedb1af2$var$HOVER_SCALE}) rotate(${hoverTilt}deg)` : 'translateY(0) scale(1) rotate(0deg)';
    const handleClick = (0, $42omo.useCallback)((event)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'omniBarEmojiSlot',
                source: $12725042cedb1af2$var$OMNIBAR_ANALYTICS_SOURCE,
                attributes: {
                    emojiId: emojiId.id || ''
                }
            }
        }).fire();
        setIsTooltipVisible(false);
        setIsHovered(false);
        const rect = event.currentTarget.getBoundingClientRect();
        const x = rect.left + rect.width / 2 - 10;
        const y = rect.top + rect.height / 2 - 20;
        triggerBloomAnimation(x, y, emojiId.id || '');
        if (!reacted && onClick) onClick();
    }, [
        onClick,
        emojiId.id,
        reacted,
        triggerBloomAnimation,
        createAnalyticsEvent
    ]);
    const handleMouseEnter = (0, $42omo.useCallback)(()=>{
        setIsTooltipVisible(true);
        setHoverTilt($12725042cedb1af2$var$getRandomHoverTilt());
        setIsHovered(true);
    }, []);
    const handleMouseLeave = (0, $42omo.useCallback)(()=>{
        setIsHovered(false);
    }, []);
    const handleFocus = (0, $42omo.useCallback)(()=>{
        setIsTooltipVisible(true);
    }, []);
    const ariaLabel = tooltipDescriptor ? formatMessage(tooltipDescriptor) : undefined;
    const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
        onClick: handleClick,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        xcss: $12725042cedb1af2$var$styles.emojiButton,
        "aria-label": ariaLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $12725042cedb1af2$var$styles.emojiInnerContainer,
        style: {
            transform: emojiHoverTransform
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $etuMO.default), {
        emojiProvider: emojiProvider,
        emojiId: emojiId,
        showTooltip: false,
        fitToHeight: (0, $387c7e4b79a2c2e2$export$56912a632457f516),
        optimisticImageURL: cloudId && emojiId.id ? (0, $yuV6Z.getOptimisticImageURL)(cloudId, emojiId.id, 'MDPI') : undefined
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, ariaLabel && isTooltipVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: ariaLabel,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $12725042cedb1af2$var$styles.tooltipTriggerWrapper
    }, button)) : button, typeof document !== 'undefined' && animatingEmojis.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $caX7N.default), {
        zIndex: (0, $dTk3A.layers).spotlight()
    }, animatingEmojis.map((animatingEmoji)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $806badad5c4e8903$export$8f2cbc3d71d39c12), {
            key: animatingEmoji.id,
            animatingEmoji: animatingEmoji,
            emojiProvider: emojiProvider,
            emojiSize: (0, $387c7e4b79a2c2e2$export$56912a632457f516)
        }))));
};
const $12725042cedb1af2$export$98b42579a0c01f69 = /*#__PURE__*/ (0, $42omo.memo)($12725042cedb1af2$var$DefaultReactionButtonInner);
$12725042cedb1af2$export$98b42579a0c01f69.displayName = 'DefaultReactionButton';


/* ReactionSummaryPopup.tsx generated by @compiled/babel-plugin v0.36.1 */ 








var $g9Srd = parcelRequire("g9Srd");

var $h3cbw = parcelRequire("h3cbw");





var $3NvVh = parcelRequire("3NvVh");








const $559fbabe644a799b$var$styles = {
    loadingCounterPlaceholder: "_2rko12b0 _1e0c1txw _4cvr1h6o _1bah1h6o _bfhksm61 _1bsb1tcg _4t3idlk8",
    loadingEmojiPlaceholder: "_2rko12b0 _1e0c1txw _4cvr1h6o _1bah1h6o _bfhksm61 _1bsb7vkz _4t3i7vkz",
    emojiContainer: "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsb7vkz _4t3i7vkz",
    popupContent: "_1rjcu2gc _18zru2gc _1bsb1ns9",
    counterContainer: "_1reo15vq _18m915vq _kqswh2mm _1x821ts4"
};
const $559fbabe644a799b$var$reactionsGridStyles = {
    grid: "_zulp1b66 _1e0c1n7u _4cvr1h6o _yv0e199o"
};
const $559fbabe644a799b$var$EmojiItemInner = ({ emojiId: emojiId, emojiProvider: emojiProvider, cloudId: cloudId })=>{
    const emojiIdObj = (0, $42omo.useMemo)(()=>({
            id: emojiId,
            shortName: (0, $387c7e4b79a2c2e2$export$12e0bba3487fb7fd)(emojiId)
        }), [
        emojiId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $559fbabe644a799b$var$styles.emojiContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $etuMO.default), {
        emojiProvider: emojiProvider,
        emojiId: emojiIdObj,
        fitToHeight: (0, $387c7e4b79a2c2e2$export$d78bee0d9fab78ad),
        showTooltip: false,
        optimisticImageURL: cloudId ? (0, $yuV6Z.getOptimisticImageURL)(cloudId, emojiId, 'MDPI') : undefined
    }));
};
const $559fbabe644a799b$var$EmojiItem = /*#__PURE__*/ (0, $42omo.memo)($559fbabe644a799b$var$EmojiItemInner);
const $559fbabe644a799b$var$EmojiList = ({ isLoading: isLoading, topReactions: topReactions, emojiProvider: emojiProvider, cloudId: cloudId })=>{
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $559fbabe644a799b$var$styles.loadingEmojiPlaceholder
    });
    if (topReactions.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.025"
    }, topReactions.map((reaction)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($559fbabe644a799b$var$EmojiItem, {
            key: reaction.emojiId,
            emojiId: reaction.emojiId,
            emojiProvider: emojiProvider,
            cloudId: cloudId
        })));
};
const $559fbabe644a799b$var$formatNumber = (num)=>{
    if (num === 0) return '';
    if (num >= 1000) return `${(num / 1000).toFixed(1)}k+`;
    return num.toString();
};
const $559fbabe644a799b$var$Counter = ({ isLoading: isLoading, totalCount: totalCount })=>{
    const previousValueRef = (0, $42omo.useRef)(undefined);
    (0, $42omo.useEffect)(()=>{
        previousValueRef.current = totalCount;
    }, [
        totalCount
    ]);
    const isIncreasing = (0, $42omo.useMemo)(()=>previousValueRef.current !== undefined && previousValueRef.current < totalCount, [
        totalCount
    ]);
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $559fbabe644a799b$var$styles.loadingCounterPlaceholder
    });
    if (totalCount === 0) return null;
    const label = $559fbabe644a799b$var$formatNumber(totalCount);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $559fbabe644a799b$var$styles.counterContainer,
        testId: "omni-bar-reaction-counter"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g9Srd.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h3cbw.default), {
        enterFrom: isIncreasing ? 'top' : 'bottom',
        exitTo: isIncreasing ? 'top' : 'bottom',
        key: totalCount,
        duration: "medium"
    }, (motion, direction)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            ref: motion.ref,
            style: {
                position: direction === 'exiting' ? 'absolute' : undefined
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: motion.className
        }, label))));
};
const $559fbabe644a799b$var$ReactionSummaryTriggerInner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(({ isOpen: isOpen, isLoading: isLoading, totalCount: totalCount, topReactions: topReactions, emojiProvider: emojiProvider, onClick: onClick, cloudId: cloudId }, ref)=>{
    const handleClick = (0, $42omo.useCallback)(()=>{
        if (!isLoading && totalCount > 0) onClick();
    }, [
        isLoading,
        totalCount,
        onClick
    ]);
    const iconContent = (0, $42omo.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($559fbabe644a799b$var$EmojiList, {
            isLoading: isLoading,
            topReactions: topReactions,
            emojiProvider: emojiProvider,
            cloudId: cloudId
        }), [
        isLoading,
        topReactions,
        emojiProvider,
        cloudId
    ]);
    const renderIcon = (0, $42omo.useCallback)(()=>iconContent, [
        iconContent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        ref: ref,
        appearance: "subtle",
        onClick: handleClick,
        isSelected: isOpen,
        testId: "omni-bar-reaction-summary-trigger",
        iconBefore: renderIcon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($559fbabe644a799b$var$Counter, {
        isLoading: isLoading,
        totalCount: totalCount
    }));
});
const $559fbabe644a799b$export$46b9d6923ba2ba99 = /*#__PURE__*/ (0, $42omo.memo)($559fbabe644a799b$var$ReactionSummaryTriggerInner);
$559fbabe644a799b$export$46b9d6923ba2ba99.displayName = 'ReactionSummaryTrigger';
const $559fbabe644a799b$var$MAX_COLUMNS = 5;
const $559fbabe644a799b$export$49a38d37ed252373 = ({ reactions: reactions, emojiProvider: emojiProvider, onReactionClick: onReactionClick })=>{
    const columnCount = Math.min(reactions.length, $559fbabe644a799b$var$MAX_COLUMNS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $559fbabe644a799b$var$styles.popupContent,
        testId: "omni-bar-reaction-summary-popup"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $559fbabe644a799b$var$reactionsGridStyles.grid,
        style: {
            '--reaction-column-count': columnCount
        }
    }, reactions.map((reaction)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3NvVh.Reaction), {
            key: reaction.emojiId,
            reaction: reaction,
            emojiProvider: emojiProvider,
            onClick: onReactionClick,
            allowUserDialog: false,
            isViewOnly: false
        }))));
};


/**
 * @generated SignedSource<<8846eb063354700142a4d46c73570480>>
 * @relayHash 534f8e942a7a9be603c661094407bcec
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e2c330cfe2a389ef29d4dca6873b21df3ce63ab4c4dfd32740a35e137109512b
const $6da456df757dd22d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "containerId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "containerType"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentType"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "emojiId"
    }, v6 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "containerId",
                            "variableName": "containerId"
                        },
                        {
                            "kind": "Variable",
                            "name": "containerType",
                            "variableName": "containerType"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentType",
                            "variableName": "contentType"
                        },
                        {
                            "kind": "Variable",
                            "name": "emojiId",
                            "variableName": "emojiId"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "ConfluenceReactionPayload",
            "kind": "LinkedField",
            "name": "confluence_deleteReaction",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "ari"
                },
                {
                    "kind": "ScalarField",
                    "name": "containerAri"
                },
                {
                    "kind": "ScalarField",
                    "name": "emojiId"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useReactionMutationsDeleteReactionMutation",
            "selections": v6 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useReactionMutationsDeleteReactionMutation",
            "selections": v6 /*: any*/ 
        },
        "params": {
            "cacheID": "534f8e942a7a9be603c661094407bcec",
            "id": "e2c330cfe2a389ef29d4dca6873b21df3ce63ab4c4dfd32740a35e137109512b",
            "metadata": {},
            "name": "useReactionMutationsDeleteReactionMutation",
            "operationKind": "mutation",
            "text": "mutation useReactionMutationsDeleteReactionMutation($cloudId:ID!,$contentId:Long!,$containerId:Long!,$containerType:ContainerType!,$contentType:GraphQLReactionContentType!,$emojiId:String!){confluence_deleteReaction(cloudId:$cloudId,input:{contentId:$contentId,containerId:$containerId,containerType:$containerType,contentType:$contentType,emojiId:$emojiId}){ari,containerAri,emojiId}}"
        }
    };
}();
$6da456df757dd22d$var$node.hash = "026dd0e0d892c04c9adf5d33242807f3";
var $6da456df757dd22d$export$2e2bcd8739ae039 = $6da456df757dd22d$var$node;


/**
 * @generated SignedSource<<23e244f35dae18a9e25c9c114c680e9e>>
 * @relayHash 4a2a6e866128a40badb1b2179a63d891
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1ba1e6729b66fc8b622f7a36d5173c8b3e342d9660af111d7f0224ce90bfb455
const $81fdb6060c63d896$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "containerId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "containerType"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentType"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "emojiId"
    }, v6 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "containerId",
                            "variableName": "containerId"
                        },
                        {
                            "kind": "Variable",
                            "name": "containerType",
                            "variableName": "containerType"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentType",
                            "variableName": "contentType"
                        },
                        {
                            "kind": "Variable",
                            "name": "emojiId",
                            "variableName": "emojiId"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "ConfluenceReactionPayload",
            "kind": "LinkedField",
            "name": "confluence_addReaction",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "ari"
                },
                {
                    "kind": "ScalarField",
                    "name": "containerAri"
                },
                {
                    "kind": "ScalarField",
                    "name": "emojiId"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useReactionMutationsAddReactionMutation",
            "selections": v6 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useReactionMutationsAddReactionMutation",
            "selections": v6 /*: any*/ 
        },
        "params": {
            "cacheID": "4a2a6e866128a40badb1b2179a63d891",
            "id": "1ba1e6729b66fc8b622f7a36d5173c8b3e342d9660af111d7f0224ce90bfb455",
            "metadata": {},
            "name": "useReactionMutationsAddReactionMutation",
            "operationKind": "mutation",
            "text": "mutation useReactionMutationsAddReactionMutation($cloudId:ID!,$contentId:Long!,$containerId:Long!,$containerType:ContainerType!,$contentType:GraphQLReactionContentType!,$emojiId:String!){confluence_addReaction(cloudId:$cloudId,input:{contentId:$contentId,containerId:$containerId,containerType:$containerType,contentType:$contentType,emojiId:$emojiId}){ari,containerAri,emojiId}}"
        }
    };
}();
$81fdb6060c63d896$var$node.hash = "547036fa0d9c77c600330473576f635a";
var $81fdb6060c63d896$export$2e2bcd8739ae039 = $81fdb6060c63d896$var$node;









var $308Wd = parcelRequire("308Wd");


var $8wyJO = parcelRequire("8wyJO");


var $5qhgL = parcelRequire("5qhgL");








var $fGzMp = parcelRequire("fGzMp");




const $57464ea87c3c7fcd$var$logger = (0, $7W8i8.getLogger)('omnibar-reactions');
const $57464ea87c3c7fcd$var$useReactionMutationsAddReactionMutation = (0, $81fdb6060c63d896$export$2e2bcd8739ae039);
const $57464ea87c3c7fcd$var$useReactionMutationsDeleteReactionMutation = (0, $6da456df757dd22d$export$2e2bcd8739ae039);
/** Optimistic response for add reaction (matches useReactionMutationsAddReactionMutation$data). */ const $57464ea87c3c7fcd$var$createAddReactionOptimisticResponse = (emojiId)=>({
        __typename: 'Mutation',
        confluence_addReaction: {
            __typename: 'ConfluenceReactionPayload',
            ari: null,
            containerAri: null,
            emojiId: emojiId
        }
    });
/** Optimistic response for delete reaction (matches useReactionMutationsDeleteReactionMutation$data). */ const $57464ea87c3c7fcd$var$createDeleteReactionOptimisticResponse = (emojiId)=>({
        __typename: 'Mutation',
        confluence_deleteReaction: {
            __typename: 'ConfluenceReactionPayload',
            ari: null,
            containerAri: null,
            emojiId: emojiId
        }
    });
/**
 * Gets updated reactions response for cache update.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $57464ea87c3c7fcd$var$getUpdatedReactionsResponse = (data, emojiId, actionType, isComment)=>{
    const summary = (0, $8wyJO.getReactionsSummary)(data);
    if (!summary) return;
    let updatedCount = summary.reactionsCount;
    const updatedReactions = [
        ...summary.reactionsSummaryForEmoji
    ];
    const reactionObject = updatedReactions.find((item)=>item?.emojiId === emojiId);
    if (actionType === 'add') {
        if (reactionObject && !reactionObject.reacted) {
            reactionObject.count++;
            reactionObject.reacted = true;
        } else updatedReactions.push({
            emojiId: emojiId,
            count: 1,
            reacted: true,
            id: `${summary.containerAri}|${summary.ari}|${emojiId}`,
            __typename: 'ReactionsSummaryForEmoji'
        });
        updatedCount++;
    }
    if (actionType === 'delete') {
        if (reactionObject && reactionObject.reacted && reactionObject.count > 1) {
            reactionObject.count--;
            reactionObject.reacted = false;
        } else {
            const removeIdx = updatedReactions.map((item)=>item?.emojiId).indexOf(emojiId);
            updatedReactions.splice(removeIdx, 1);
        }
        updatedCount--;
    }
    const getContentResponseData = ()=>({
            ...data,
            content: {
                ...data.content,
                nodes: [
                    {
                        ...data.content.nodes[0],
                        contentReactionsSummary: {
                            ...summary,
                            reactionsSummaryForEmoji: updatedReactions,
                            reactionsCount: updatedCount
                        }
                    }
                ]
            }
        });
    return isComment ? {
        ...data,
        comments: {
            ...data.comments,
            nodes: [
                {
                    ...data.comments.nodes[0],
                    reactionsSummary: {
                        ...summary,
                        reactionsSummaryForEmoji: updatedReactions,
                        reactionsCount: updatedCount
                    }
                }
            ]
        }
    } : getContentResponseData();
};
const $57464ea87c3c7fcd$export$c666d2c09581fced = ({ contentId: contentId, spaceId: spaceId, contentType: contentType, contentSubType: contentSubType, cloudId: cloudId, edition: edition, reactionsMap: reactionsMap })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const activeReactionsRef = (0, $42omo.useRef)(new Set());
    const { isComment: isComment } = (0, $5qhgL.getBooleanLocationTypes)(contentType);
    const [addReaction] = (0, $308Wd.useMutationInterop)($57464ea87c3c7fcd$var$useReactionMutationsAddReactionMutation);
    const [deleteReaction] = (0, $308Wd.useMutationInterop)($57464ea87c3c7fcd$var$useReactionMutationsDeleteReactionMutation);
    const updateApolloCache = (0, $42omo.useCallback)((emojiId, actionType)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (cache, result)=>{
            if (!result) return;
            const { query: query, queryVariables: queryVariables } = (0, $8wyJO.getReactionsQueryInfo)(isComment, contentId, spaceId);
            try {
                const response = cache.readQuery({
                    query: query,
                    variables: queryVariables
                });
                const updatedResponse = $57464ea87c3c7fcd$var$getUpdatedReactionsResponse(response, emojiId, actionType, isComment);
                if (updatedResponse) cache.writeQuery({
                    query: query,
                    variables: queryVariables,
                    data: updatedResponse
                });
            } catch (err) {
                $57464ea87c3c7fcd$var$logger.error`An error occurred when updating cache for omnibar reaction - ${err}`;
            }
        }, [
        contentId,
        spaceId,
        isComment
    ]);
    const handleDefaultReactionClick = (0, $42omo.useCallback)((emojiId)=>{
        if (activeReactionsRef.current.has(emojiId)) return;
        const existingReaction = reactionsMap.get(emojiId);
        if (existingReaction?.reacted) return;
        if (!cloudId || !contentId || !spaceId || !contentType) return;
        activeReactionsRef.current.add(emojiId);
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        experienceTracker.start({
            name: (0, $irVI7.OMNIBAR_ADD_REACTION_EXPERIENCE),
            attributes: {
                contentId: contentId,
                contentType: contentType,
                emojiId: emojiId,
                placement: 'omni-bar'
            }
        });
        addReaction({
            variables: {
                cloudId: cloudId || '',
                contentId: Number(contentId),
                contentType: contentType?.toUpperCase(),
                containerId: Number(spaceId),
                containerType: (0, $3FlVr.ReactionContainerType).SPACE.toUpperCase(),
                emojiId: emojiId
            },
            update: updateApolloCache(emojiId, 'add'),
            optimisticResponse: $57464ea87c3c7fcd$var$createAddReactionOptimisticResponse(emojiId)
        }).then(()=>{
            activeReactionsRef.current.delete(emojiId);
            experienceTracker.succeed({
                name: (0, $irVI7.OMNIBAR_ADD_REACTION_EXPERIENCE)
            });
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'created',
                    actionSubject: 'reaction',
                    source: contentType,
                    attributes: {
                        objectId: contentId,
                        objectType: contentType,
                        containerId: spaceId,
                        containerType: (0, $3FlVr.ReactionContainerType).SPACE,
                        emojiId: emojiId,
                        displayType: contentType,
                        isLivePage: contentSubType === 'live',
                        reactionsPlacement: 'omni-bar',
                        edition: edition
                    }
                }
            }).fire();
        }).catch((error)=>{
            activeReactionsRef.current.delete(emojiId);
            $57464ea87c3c7fcd$var$logger.error`Failed to add reaction in omnibar: ${error}`;
            experienceTracker.stopOnError({
                name: (0, $irVI7.OMNIBAR_ADD_REACTION_EXPERIENCE),
                error: error instanceof Error ? error : new Error(String(error))
            });
        });
    }, [
        reactionsMap,
        addReaction,
        cloudId,
        contentId,
        contentType,
        spaceId,
        updateApolloCache,
        createAnalyticsEvent,
        contentSubType,
        edition
    ]);
    const handleSummaryReactionClick = (0, $42omo.useCallback)((emojiId)=>{
        if (activeReactionsRef.current.has(emojiId)) return;
        if (!cloudId || !contentId || !spaceId || !contentType) return;
        const existingReaction = reactionsMap.get(emojiId);
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        if (!existingReaction?.reacted) {
            activeReactionsRef.current.add(emojiId);
            experienceTracker.start({
                name: (0, $irVI7.OMNIBAR_ADD_REACTION_EXPERIENCE),
                attributes: {
                    contentId: contentId,
                    contentType: contentType,
                    emojiId: emojiId,
                    placement: 'omni-bar-summary'
                }
            });
            addReaction({
                variables: {
                    cloudId: cloudId || '',
                    contentId: Number(contentId),
                    contentType: contentType?.toUpperCase(),
                    containerId: Number(spaceId),
                    containerType: (0, $3FlVr.ReactionContainerType).SPACE.toUpperCase(),
                    emojiId: emojiId
                },
                update: updateApolloCache(emojiId, 'add'),
                optimisticResponse: $57464ea87c3c7fcd$var$createAddReactionOptimisticResponse(emojiId)
            }).then(()=>{
                activeReactionsRef.current.delete(emojiId);
                experienceTracker.succeed({
                    name: (0, $irVI7.OMNIBAR_ADD_REACTION_EXPERIENCE)
                });
            }).catch((error)=>{
                activeReactionsRef.current.delete(emojiId);
                $57464ea87c3c7fcd$var$logger.error`Failed to add reaction from summary in omnibar: ${error}`;
                experienceTracker.stopOnError({
                    name: (0, $irVI7.OMNIBAR_ADD_REACTION_EXPERIENCE),
                    error: error instanceof Error ? error : new Error(String(error))
                });
            });
            return;
        }
        activeReactionsRef.current.add(emojiId);
        experienceTracker.start({
            name: (0, $irVI7.OMNIBAR_DELETE_REACTION_EXPERIENCE),
            attributes: {
                contentId: contentId,
                contentType: contentType,
                emojiId: emojiId,
                placement: 'omni-bar-summary'
            }
        });
        deleteReaction({
            variables: {
                cloudId: cloudId || '',
                contentId: Number(contentId),
                contentType: contentType?.toUpperCase(),
                containerId: Number(spaceId),
                containerType: (0, $3FlVr.ReactionContainerType).SPACE.toUpperCase(),
                emojiId: emojiId
            },
            update: updateApolloCache(emojiId, 'delete'),
            optimisticResponse: $57464ea87c3c7fcd$var$createDeleteReactionOptimisticResponse(emojiId)
        }).then(()=>{
            activeReactionsRef.current.delete(emojiId);
            experienceTracker.succeed({
                name: (0, $irVI7.OMNIBAR_DELETE_REACTION_EXPERIENCE)
            });
        }).catch((error)=>{
            activeReactionsRef.current.delete(emojiId);
            $57464ea87c3c7fcd$var$logger.error`Failed to delete reaction in omnibar: ${error}`;
            experienceTracker.stopOnError({
                name: (0, $irVI7.OMNIBAR_DELETE_REACTION_EXPERIENCE),
                error: error instanceof Error ? error : new Error(String(error))
            });
        });
    }, [
        addReaction,
        deleteReaction,
        cloudId,
        contentId,
        contentType,
        spaceId,
        reactionsMap,
        updateApolloCache
    ]);
    return {
        handleDefaultReactionClick: handleDefaultReactionClick,
        handleSummaryReactionClick: handleSummaryReactionClick
    };
};





const $c49579fe5d161c4c$var$PICKER_SELECTOR = '[data-emoji-picker-container]';
const $c49579fe5d161c4c$export$677c63a231082721 = ()=>{
    const [isEmojiPickerOpen, setIsEmojiPickerOpen] = (0, $42omo.useState)(false);
    const debounceFrameIdRef = (0, $42omo.useRef)(null);
    const pollFrameIdRef = (0, $42omo.useRef)(null);
    const observerRef = (0, $42omo.useRef)(null);
    const isOpenRef = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (typeof document === 'undefined' || typeof window === 'undefined') return;
        let idleCallbackId = null;
        let isMounted = true;
        const checkPickerOpen = ()=>{
            const pickerElement = document.querySelector($c49579fe5d161c4c$var$PICKER_SELECTOR);
            return pickerElement !== null;
        };
        const updateState = (isOpen)=>{
            // Only update state if component is still mounted and state actually changed
            if (!isMounted) return;
            if (isOpenRef.current !== isOpen) {
                isOpenRef.current = isOpen;
                setIsEmojiPickerOpen(isOpen);
            }
        };
        const startPolling = ()=>{
            if (pollFrameIdRef.current !== null) return; // Already polling
            const poll = ()=>{
                // Guard: don't continue if component unmounted
                if (!isMounted || pollFrameIdRef.current === null) return;
                const stillOpen = checkPickerOpen();
                updateState(stillOpen);
                if (!stillOpen) {
                    // Picker closed, stop polling and reconnect observer
                    pollFrameIdRef.current = null;
                    if (isMounted && observerRef.current) observerRef.current.observe(document.body, {
                        childList: true,
                        subtree: true
                    });
                } else if (isMounted) pollFrameIdRef.current = window.requestAnimationFrame(poll);
            };
            pollFrameIdRef.current = window.requestAnimationFrame(poll);
        };
        const stopPolling = ()=>{
            if (pollFrameIdRef.current !== null) {
                window.cancelAnimationFrame(pollFrameIdRef.current);
                pollFrameIdRef.current = null;
            }
        };
        const debouncedCheck = ()=>{
            if (debounceFrameIdRef.current === null) debounceFrameIdRef.current = window.requestAnimationFrame(()=>{
                // Guard: don't process if component unmounted
                if (!isMounted) {
                    debounceFrameIdRef.current = null;
                    return;
                }
                const isOpen = checkPickerOpen();
                updateState(isOpen);
                // If picker just opened and we're observing, switch to polling
                if (isOpen && isMounted && observerRef.current && pollFrameIdRef.current === null) {
                    observerRef.current.disconnect();
                    startPolling();
                }
                debounceFrameIdRef.current = null;
            });
        };
        const setupObserver = ()=>{
            observerRef.current = new MutationObserver((mutations)=>{
                const hasRelevantChanges = mutations.some((mutation)=>{
                    if (mutation.type !== 'childList') return false;
                    return mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0;
                });
                if (hasRelevantChanges) debouncedCheck();
            });
            const isOpen = checkPickerOpen();
            updateState(isOpen);
            if (isOpen) startPolling();
            else observerRef.current.observe(document.body, {
                childList: true,
                subtree: true
            });
        };
        if (typeof window !== 'undefined' && 'requestIdleCallback' in window) idleCallbackId = window.requestIdleCallback(()=>setupObserver(), {
            timeout: 200
        });
        else idleCallbackId = setTimeout(setupObserver, 50);
        return ()=>{
            isMounted = false;
            if (debounceFrameIdRef.current !== null) {
                window.cancelAnimationFrame(debounceFrameIdRef.current);
                debounceFrameIdRef.current = null;
            }
            stopPolling();
            if (observerRef.current) {
                observerRef.current.disconnect();
                observerRef.current = null;
            }
            if (idleCallbackId !== null) {
                if (typeof window !== 'undefined' && 'cancelIdleCallback' in window && typeof idleCallbackId === 'number') window.cancelIdleCallback(idleCallbackId);
                else clearTimeout(idleCallbackId);
            }
        };
    }, []);
    return isEmojiPickerOpen;
};




const $95d3cc090e2e45a6$var$DEFAULT_EMOJI_COUNT = 5;
const $95d3cc090e2e45a6$var$OMNIBAR_ANALYTICS_SOURCE = 'confluenceOmniBar';
const $95d3cc090e2e45a6$var$i18n = (0, $cgtv4.defineMessages)({
    addReaction: {
        id: "experiment-omnibar.reactions.more-reactions",
        defaultMessage: "More reactions"
    }
});
const $95d3cc090e2e45a6$var$styles = {
    reactionsContainer: "_zulpidpf _2rko12b0 _1reoewfl _18m9ewfl _1e0c1txw _4cvr1h6o _1bsb1wug _1ul9194s _4t3izwfg _1bah1y6m _1o9zidpf _lcxv1wug",
    emojiPickerWrapper: "_1e0c1txw _4cvr1h6o _1bah1h6o _1o9zidpf _1bsbzwfg _4t3izwfg _lcxv1wug",
    separator: "_1bsbt94y _1ul9t94y _4t3i1tcg _18u0u2gc _2hwxu2gc _1o9zidpf _1wpz1h6o _1e0c1ule",
    summaryContainer: "_1e0c1txw _4cvr1h6o _4t3izwfg _lcxv1wug"
};
const $95d3cc090e2e45a6$var$SEPARATOR_BORDER_STYLE = {
    borderLeft: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`
};
const $95d3cc090e2e45a6$var$DEFAULT_EMOJI_IDS = new Set((0, $387c7e4b79a2c2e2$export$f15a7d7a553aca16).map((e)=>e.id));
const $95d3cc090e2e45a6$var$EMPTY_QUICK_REACTION_IDS = [];
const $95d3cc090e2e45a6$var$createReactionsMap = (reactions)=>{
    const map = new Map();
    reactions?.forEach((reaction)=>{
        map.set(reaction.emojiId, reaction);
    });
    return map;
};
const $95d3cc090e2e45a6$var$getTopReactions = (reactions, count = 3)=>{
    if (!reactions) return [];
    const reactionsWithCount = reactions.filter((reaction)=>reaction.count > 0);
    const sorted = [
        ...reactionsWithCount
    ].sort((a, b)=>b.count - a.count);
    return sorted.slice(0, count);
};
const $95d3cc090e2e45a6$var$convertToReactionSummaries = (reactions, spaceId, contentId)=>{
    if (!reactions) return [];
    const result = [];
    for (const reaction of reactions)if (reaction.count > 0) result.push({
        emojiId: reaction.emojiId,
        count: reaction.count,
        reacted: reaction.reacted || false,
        ari: reaction.ari || `${spaceId}|${contentId}|${reaction.emojiId}`,
        containerAri: reaction.containerAri || spaceId || ''
    });
    return result;
};
const $95d3cc090e2e45a6$var$OmniBarReactionsInner = ({ contentId: contentId, spaceId: spaceId, contentType: contentType, contentSubType: contentSubType, emojiCount: emojiCount = $95d3cc090e2e45a6$var$DEFAULT_EMOJI_COUNT, reactionsData: reactionsData, isLoading: isLoading = false, shouldCloseInteractions: shouldCloseInteractions = false, shouldShowBloom: shouldShowBloom = true, onInteractionStateChange: onInteractionStateChange })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { edition: edition, cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const { Popup: Popup } = (0, $lsxnT.useChoreographerAssets)();
    const emojiProviderPromise = (0, $42omo.useMemo)(()=>(0, $32x2E.getEmojiProvider)((0, $ibzAc.default), {
            cloudId: cloudId || '',
            userId: userId || undefined,
            disableUpload: true
        }), [
        cloudId,
        userId
    ]);
    const reactionsMap = (0, $42omo.useMemo)(()=>$95d3cc090e2e45a6$var$createReactionsMap(reactionsData?.reactions), [
        reactionsData?.reactions
    ]);
    const topReactions = (0, $42omo.useMemo)(()=>$95d3cc090e2e45a6$var$getTopReactions(reactionsData?.reactions, 3), [
        reactionsData?.reactions
    ]);
    const { handleDefaultReactionClick: handleDefaultReactionClick, handleSummaryReactionClick: handleSummaryReactionClick } = (0, $57464ea87c3c7fcd$export$c666d2c09581fced)({
        contentId: contentId,
        spaceId: spaceId,
        contentType: contentType,
        contentSubType: contentSubType,
        cloudId: cloudId,
        edition: edition ?? undefined,
        reactionsMap: reactionsMap
    });
    const [isSummaryPopupOpen, setIsSummaryPopupOpen] = (0, $42omo.useState)(false);
    const isEmojiPickerOpen = (0, $c49579fe5d161c4c$export$677c63a231082721)();
    const { animatingEmojis: animatingEmojis, triggerBloomAnimation: triggerBloomAnimation } = (0, $9db24e0dc1ddcbfa$export$673194083bf9485c)();
    const summaryTriggerRef = (0, $42omo.useRef)(null);
    const previousReactedStateRef = (0, $42omo.useRef)(new Set());
    const previousPickerOpenRef = (0, $42omo.useRef)(false);
    const pickerWasOpenRecentlyRef = (0, $42omo.useRef)(false);
    const isInitialLoadRef = (0, $42omo.useRef)(true);
    (0, $42omo.useEffect)(()=>{
        if (isEmojiPickerOpen) pickerWasOpenRecentlyRef.current = true;
        else if (previousPickerOpenRef.current && !isEmojiPickerOpen) {
            pickerWasOpenRecentlyRef.current = true;
            const timeoutId = setTimeout(()=>{
                pickerWasOpenRecentlyRef.current = false;
            }, 1000);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        previousPickerOpenRef.current = isEmojiPickerOpen;
    }, [
        isEmojiPickerOpen
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!reactionsData?.reactions) return;
        const currentReactedEmojis = new Set();
        reactionsData.reactions.forEach((r)=>{
            if (r.reacted) currentReactedEmojis.add(r.emojiId);
        });
        if (isInitialLoadRef.current) {
            isInitialLoadRef.current = false;
            previousReactedStateRef.current = currentReactedEmojis;
            return;
        }
        const previousReactedEmojis = previousReactedStateRef.current;
        const pickerWasOpen = isEmojiPickerOpen || pickerWasOpenRecentlyRef.current;
        const newReactions = [];
        for (const r of reactionsData.reactions)if (r.reacted && !$95d3cc090e2e45a6$var$DEFAULT_EMOJI_IDS.has(r.emojiId) && !previousReactedEmojis.has(r.emojiId)) newReactions.push(r);
        if (shouldShowBloom && pickerWasOpen && newReactions.length > 0 && summaryTriggerRef.current) {
            const rect = summaryTriggerRef.current.getBoundingClientRect();
            const x = rect.left + rect.width / 2;
            const y = rect.top;
            newReactions.forEach((reaction)=>{
                triggerBloomAnimation(x, y, reaction.emojiId);
            });
        }
        previousReactedStateRef.current = currentReactedEmojis;
    }, [
        reactionsData,
        isEmojiPickerOpen,
        triggerBloomAnimation,
        shouldShowBloom
    ]);
    const totalCount = reactionsData?.totalCount || 0;
    const shouldShowSummary = totalCount >= 1;
    const closeEmojiPicker = (0, $42omo.useCallback)((pickerIsOpen)=>{
        if (typeof document === 'undefined' || !pickerIsOpen) return;
        document.dispatchEvent(new KeyboardEvent('keydown', {
            key: 'Escape',
            code: 'Escape',
            bubbles: true,
            cancelable: true
        }));
        if (document.activeElement instanceof HTMLElement) document.activeElement.blur();
        const triggerButton = document.querySelector('[data-testid="reactionPicker-testid"] button');
        if (triggerButton) triggerButton.click();
    }, []);
    (0, $42omo.useEffect)(()=>{
        if (shouldCloseInteractions) {
            setIsSummaryPopupOpen(false);
            const pickerOpen = isEmojiPickerOpen;
            requestAnimationFrame(()=>{
                closeEmojiPicker(pickerOpen);
            });
        }
    }, [
        shouldCloseInteractions,
        closeEmojiPicker,
        isEmojiPickerOpen
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!shouldShowSummary) setIsSummaryPopupOpen(false);
    }, [
        shouldShowSummary
    ]); // Notify parent when interaction state changes
    (0, $42omo.useEffect)(()=>{
        onInteractionStateChange?.(isEmojiPickerOpen || isSummaryPopupOpen);
    }, [
        isEmojiPickerOpen,
        isSummaryPopupOpen,
        onInteractionStateChange
    ]);
    const visibleReactions = (0, $42omo.useMemo)(()=>(0, $387c7e4b79a2c2e2$export$f15a7d7a553aca16).slice(0, emojiCount), [
        emojiCount
    ]);
    const allReactionsForModal = (0, $42omo.useMemo)(()=>$95d3cc090e2e45a6$var$convertToReactionSummaries(reactionsData?.reactions, spaceId, contentId), [
        reactionsData?.reactions,
        spaceId,
        contentId
    ]);
    const emojiClickHandlers = (0, $42omo.useMemo)(()=>{
        const handlers = {};
        for (const emoji of (0, $387c7e4b79a2c2e2$export$f15a7d7a553aca16)){
            const emojiId = emoji.id || '';
            handlers[emojiId] = ()=>handleDefaultReactionClick(emojiId);
        }
        return handlers;
    }, [
        handleDefaultReactionClick
    ]);
    const handlePopupClose = (0, $42omo.useCallback)(()=>setIsSummaryPopupOpen(false), []);
    const handleSummaryTriggerClick = (0, $42omo.useCallback)(()=>{
        if (!isLoading && totalCount > 0) {
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'omniBarReactionSummary',
                    source: $95d3cc090e2e45a6$var$OMNIBAR_ANALYTICS_SOURCE
                }
            }).fire();
            setIsSummaryPopupOpen((prev)=>!prev);
        }
    }, [
        isLoading,
        totalCount,
        createAnalyticsEvent
    ]);
    const renderPopupContent = (0, $42omo.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $559fbabe644a799b$export$49a38d37ed252373), {
            reactions: allReactionsForModal,
            emojiProvider: emojiProviderPromise,
            onReactionClick: handleSummaryReactionClick
        }), [
        allReactionsForModal,
        emojiProviderPromise,
        handleSummaryReactionClick
    ]);
    const customAnalyticsAttributes = (0, $42omo.useMemo)(()=>({
            edition: edition,
            reactionsPlacement: 'omni-bar'
        }), [
        edition
    ]);
    const addReactionLabel = formatMessage($95d3cc090e2e45a6$var$i18n.addReaction);
    const reactionPickerTriggerIcon = (0, $42omo.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4FHTF))), {
            label: addReactionLabel,
            color: "var(--ds-icon-subtle, #505258)"
        }), [
        addReactionLabel
    ]);
    const renderTrigger = (0, $42omo.useCallback)((triggerProps)=>{
        const { ref: popupRef, ...restProps } = triggerProps;
        const handleRef = (node)=>{
            summaryTriggerRef.current = node;
            if (popupRef) {
                if (typeof popupRef === 'function') popupRef(node);
            }
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $559fbabe644a799b$export$46b9d6923ba2ba99), {
            ...restProps,
            ref: handleRef,
            isOpen: isSummaryPopupOpen,
            isLoading: isLoading,
            totalCount: totalCount,
            topReactions: topReactions,
            emojiProvider: emojiProviderPromise,
            onClick: handleSummaryTriggerClick,
            cloudId: cloudId ?? undefined
        });
    }, [
        isSummaryPopupOpen,
        isLoading,
        totalCount,
        topReactions,
        emojiProviderPromise,
        handleSummaryTriggerClick,
        cloudId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        xcss: $95d3cc090e2e45a6$var$styles.reactionsContainer
    }, visibleReactions.map((emoji)=>{
        const emojiId = emoji.id || '';
        const existingReaction = reactionsMap.get(emojiId);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $12725042cedb1af2$export$98b42579a0c01f69), {
            key: emojiId,
            emojiId: emoji,
            emojiProvider: emojiProviderPromise,
            reacted: existingReaction?.reacted || false,
            onClick: emojiClickHandlers[emojiId],
            tooltipDescriptor: emoji.tooltipDescriptor,
            cloudId: cloudId ?? undefined
        });
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $95d3cc090e2e45a6$var$styles.emojiPickerWrapper,
        "data-emoji-picker-open": isEmojiPickerOpen || undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1NF8X.ReactionsLoader), {
        contentId: contentId,
        location: contentType,
        containerId: spaceId,
        containerType: (0, $3FlVr.ReactionContainerType).SPACE,
        contentSubType: contentSubType,
        customAnalyticsAttributes: customAnalyticsAttributes,
        onlyRenderPicker: true,
        pickerQuickReactionEmojiIds: $95d3cc090e2e45a6$var$EMPTY_QUICK_REACTION_IDS,
        useDefaultStyledContainer: true,
        isSubtle: true,
        hidePlaceholder: true,
        showAddReactionText: false,
        hideNoReactionsText: true,
        reactionPickerTriggerIcon: reactionPickerTriggerIcon
    })), shouldShowSummary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $95d3cc090e2e45a6$var$styles.separator,
        style: $95d3cc090e2e45a6$var$SEPARATOR_BORDER_STYLE,
        testId: "omni-bar-reaction-separator"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Popup, {
        placement: "top-start",
        content: renderPopupContent,
        isOpen: isSummaryPopupOpen,
        onClose: handlePopupClose,
        trigger: renderTrigger,
        offset: [
            0,
            8
        ]
    })), typeof document !== 'undefined' && animatingEmojis.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $caX7N.default), {
        zIndex: (0, $dTk3A.layers).spotlight()
    }, animatingEmojis.map((animatingEmoji)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $806badad5c4e8903$export$8f2cbc3d71d39c12), {
            key: animatingEmoji.id,
            animatingEmoji: animatingEmoji,
            emojiProvider: emojiProviderPromise,
            emojiSize: (0, $387c7e4b79a2c2e2$export$56912a632457f516)
        }))));
};
const $95d3cc090e2e45a6$export$3366148778529365 = /*#__PURE__*/ (0, $42omo.memo)($95d3cc090e2e45a6$var$OmniBarReactionsInner);
$95d3cc090e2e45a6$export$3366148778529365.displayName = 'OmniBarReactions';





const $be5272beb8fc0b67$var$defaultEligibility = {
    showReactions: false,
    showComments: false
};
const $be5272beb8fc0b67$export$8cbbebd8b79b4697 = /*#__PURE__*/ (0, $42omo.createContext)($be5272beb8fc0b67$var$defaultEligibility);
const $be5272beb8fc0b67$export$e7639907c46a9b3c = $be5272beb8fc0b67$export$8cbbebd8b79b4697.Provider;
const $be5272beb8fc0b67$export$3ec4f93cedb84cf3 = ()=>(0, $42omo.useContext)($be5272beb8fc0b67$export$8cbbebd8b79b4697);






var $jMyy4 = parcelRequire("jMyy4");







const $ca2a3913d7f214d1$var$EMPTY_REACTIONS_DATA = {
    reactions: [],
    totalCount: 0,
    ari: '',
    containerAri: ''
};
/**
 * Transforms raw GraphQL reactions data to the expected format.
 */ const $ca2a3913d7f214d1$var$transformReactionsData = (rawReactionsData)=>{
    const summary = (0, $8wyJO.getReactionsSummary)(rawReactionsData);
    if (!summary) return $ca2a3913d7f214d1$var$EMPTY_REACTIONS_DATA;
    const reactionNodes = summary.reactionsSummaryForEmoji || [];
    const reactions = [];
    for (const node of reactionNodes)if (node !== null) reactions.push({
        ari: summary.ari || '',
        containerAri: summary.containerAri || '',
        emojiId: node.emojiId,
        count: node.count,
        reacted: node.reacted || false,
        users: []
    });
    return {
        reactions: reactions,
        totalCount: summary.reactionsCount || 0,
        ari: summary.ari || '',
        containerAri: summary.containerAri || ''
    };
};
const $ca2a3913d7f214d1$export$1d9818af02dc36d3 = ({ contentId: contentId, spaceId: spaceId, contentType: contentType, skip: skip })=>{
    const queryInfo = (0, $42omo.useMemo)(()=>{
        if (skip) return null;
        try {
            const { isComment: isComment } = (0, $5qhgL.getBooleanLocationTypes)(contentType);
            return (0, $8wyJO.getReactionsQueryInfo)(isComment, contentId, spaceId);
        } catch  {
            return null;
        }
    }, [
        skip,
        contentType,
        contentId,
        spaceId
    ]);
    const { data: rawReactionsData, loading: loading, error: reactionsError } = (0, $jMyy4.useQueryInterop)(queryInfo?.query ?? {}, {
        variables: queryInfo?.queryVariables,
        fetchPolicy: 'cache-only',
        errorPolicy: 'all',
        skip: skip || !queryInfo?.queryVariables
    });
    const reactionsData = (0, $42omo.useMemo)(()=>{
        if (reactionsError || !rawReactionsData) return $ca2a3913d7f214d1$var$EMPTY_REACTIONS_DATA;
        return $ca2a3913d7f214d1$var$transformReactionsData(rawReactionsData);
    }, [
        rawReactionsData,
        reactionsError
    ]);
    return {
        reactionsData: reactionsData,
        isLoading: loading
    };
};














const $a99c3d99e220f083$var$OMNIBAR_ANALYTICS_SOURCE = 'confluenceOmniBar';
const $a99c3d99e220f083$export$9d7d170793476655 = (onCommentClick)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { expandCommentContainer: expandCommentContainer, setFooterEditorEntry: setFooterEditorEntry } = (0, $fNzRA.useObjectCommentDispatchContext)();
    const { expanded: expanded, isObjectCommentWrapperVisible: isObjectCommentWrapperVisible, footerEditorEntry: footerEditorEntry } = (0, $fNzRA.useObjectCommentContext)();
    const { addFooterCommentAdf: addFooterCommentAdf } = (0, $3mVfX.useCommentsPanelState)();
    const handleCommentClick = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'omniBarCommentSection',
                source: $a99c3d99e220f083$var$OMNIBAR_ANALYTICS_SOURCE
            }
        }).fire();
        const isShowStickyDraft = !isObjectCommentWrapperVisible && (addFooterCommentAdf || expanded) && footerEditorEntry !== (0, $fNzRA.AddFooterCommentMode).STICKY_DRAFT;
        if (!expanded) expandCommentContainer({
            entryPoint: 'pageFooter'
        });
        if (isShowStickyDraft || !isObjectCommentWrapperVisible) setFooterEditorEntry((0, $fNzRA.AddFooterCommentMode).STICKY_DRAFT);
        else if (typeof document !== 'undefined') document.querySelector(`[data-testid='object-comment-wrapper']`)?.scrollIntoView({
            behavior: 'smooth'
        });
        onCommentClick?.();
    }, [
        createAnalyticsEvent,
        expandCommentContainer,
        setFooterEditorEntry,
        expanded,
        isObjectCommentWrapperVisible,
        footerEditorEntry,
        addFooterCommentAdf,
        onCommentClick
    ]);
    return {
        handleCommentClick: handleCommentClick
    };
};


const $3117c19d34064be1$var$logger = (0, $7W8i8.getLogger)('experiment-omnibar');
const $3117c19d34064be1$var$OMNIBAR_ANALYTICS_SOURCE = 'confluenceOmniBar';
function $3117c19d34064be1$var$wasOmnibarSSRd() {
    if (typeof document === 'undefined') return false;
    const omnibarElement = document.querySelector('[data-testid="omni-bar"]');
    if (!omnibarElement) return false;
    const computedElementStyle = window.getComputedStyle(omnibarElement); // The SSR'd omnibar uses position: sticky; the CSR version uses position: fixed
    return computedElementStyle.position === 'sticky' && computedElementStyle.visibility !== 'hidden';
}
function $3117c19d34064be1$var$getPinStateFromStorage() {
    try {
        const stored = (0, $17wUi.confluenceSessionStorageInstance)?.getItem((0, $1UApO.keys).OMNIBAR_PINNED);
        if (stored === 'true') return true;
        if (stored === 'false') return false;
    } catch (e) {
        $3117c19d34064be1$var$logger.error`Omnibar failed to read pin state from session storage: ${e}`;
    }
    return true;
}
function $3117c19d34064be1$var$persistPinState(pinned) {
    try {
        (0, $17wUi.confluenceSessionStorageInstance)?.setItem((0, $1UApO.keys).OMNIBAR_PINNED, pinned ? 'true' : 'false');
    } catch (e) {
        $3117c19d34064be1$var$logger.error`Omnibar failed to persist pin state to session storage: ${e}`;
    }
}
const $3117c19d34064be1$var$i18n = (0, $cgtv4.defineMessages)({
    hideOmniBar: {
        id: "experiment-omnibar.omni-bar.hide-button",
        defaultMessage: "Hide toolbar"
    },
    pinOmniBar: {
        id: "experiment-omnibar.omni-bar.pin-button",
        defaultMessage: "Pin toolbar"
    },
    comment: {
        id: "experiment-omnibar.comments.comment-button",
        defaultMessage: "Comment"
    }
});
const $3117c19d34064be1$var$styles = {
    responsiveContainer: "_1reoewfl _18m9ewfl _kqsw1n9t _1e0c1txw _4cvresu3 _1bah1h6o _4t3it9kd _94n5ze3t _n3td1ejb _1pbykb7n",
    responsiveContainerInner: "_1bsb1osq _1e0c1txw _1bah1h6o _4cvresu3",
    barContainerBase: "_v5641w5x _1bsb1ns9 _lcxv1wug _tzy4kb7n _t9ec1kli",
    barHidden: "_t9ec3k1b _tzy4idpf _lcxvglyw",
    barSlideIn: "_t9ec1kli _tzy4kb7n _lcxv1wug",
    barNoTransition: "_v564glyw",
    buttonStyle: "_2rkopb1k _bfhkhp5a _16qst7xp",
    reactionsContainerBase: "_1yt4u2gc _1reoewfl _18m9ewfl",
    commentsContainerBase: "_1yt4u2gc",
    noPointerEvents: "_lcxvglyw",
    containerHiddenWhenDimensionsNotReady: "_3um015vq",
    pinContainerBase: "_2rko1rr0 _v56416ea _bfhkhp5a",
    horizontalCenteringFixForToggleButton: "_19bv1jfw",
    pinButtonHiddenWhenNotHovered: "_tzy4idpf _lcxvglyw",
    ssrContainerStyle: "_kqsw1if8"
};
const $3117c19d34064be1$export$d4fe9bcf0aa84dd5 = ({ contentId: contentId, spaceId: spaceId, contentType: contentType, contentSubType: contentSubType, onCommentClick: onCommentClick })=>{
    const isSSR = typeof window === 'undefined'; /**
                                                * Detect if an SSR'd omnibar is already visible — call only once and cache in ref.
                                                * This must not be called on every render because subsequent renders commit client
                                                * styles to the DOM, making the check return stale results.
                                                */ 
    const wasOmnibarSSRdRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(null);
    if (wasOmnibarSSRdRef.current === null) wasOmnibarSSRdRef.current = isSSR || $3117c19d34064be1$var$wasOmnibarSSRd();
    const isHydratingAfterSSR = wasOmnibarSSRdRef.current;
    const [hasHydrated, setHasHydrated] = (0, $42omo.useState)(!isHydratingAfterSSR);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isPinned, setIsPinned] = (0, $42omo.useState)(true);
    const [isHovered, setIsHovered] = (0, $42omo.useState)(false);
    const [shouldHideInstantly, setHideInstantly] = (0, $42omo.useState)(false);
    const [isAnimatingOut, setIsAnimatingOut] = (0, $42omo.useState)(false);
    const [hasActiveInteraction, setHasActiveInteraction] = (0, $42omo.useState)(false);
    const [hasCompletedInitialSlideUp, setHasCompletedInitialSlideUp] = (0, $42omo.useState)(isHydratingAfterSSR);
    const [isAnimatingOutForUnmount, setIsAnimatingOutForUnmount] = (0, $42omo.useState)(false);
    const containerRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(null);
    const isMountedRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(true);
    const barWasVisibleRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(false); // Track if we rendered on server to know whether to skip animation
    const wasServerRenderedRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(isHydratingAfterSSR);
    (0, $42omo.useEffect)(()=>{
        if (isHydratingAfterSSR) setHasHydrated(true);
    }, [
        isHydratingAfterSSR
    ]);
    (0, $42omo.useEffect)(()=>{
        setIsPinned($3117c19d34064be1$var$getPinStateFromStorage());
    }, []);
    const handleOmniBarMouseEnter = (0, $42omo.useCallback)(()=>{
        if (isAnimatingOut) return;
        setHideInstantly(false);
        setIsHovered(true);
    }, [
        isAnimatingOut
    ]);
    const handleOmniBarMouseLeave = (0, $42omo.useCallback)(()=>{
        setIsHovered(false);
    }, []);
    (0, $42omo.useEffect)(()=>{
        const container = containerRef.current;
        if (!container || isPinned) return;
        const handleNativeMouseLeave = (e)=>{
            const relatedTarget = e.relatedTarget;
            if (relatedTarget) {
                if (container.contains(relatedTarget)) return;
            } // Don't hide if a popup interaction is active (emoji picker, summary popup)
            if (hasActiveInteraction) return;
            setIsAnimatingOut(true);
            setIsHovered(false);
            setTimeout(()=>{
                setIsAnimatingOut(false);
            }, 300);
        };
        container.addEventListener('mouseleave', handleNativeMouseLeave);
        return ()=>{
            container.removeEventListener('mouseleave', handleNativeMouseLeave);
        };
    }, [
        isPinned,
        hasActiveInteraction
    ]);
    const shouldHideExternally = (0, $b0EGa.useShouldHideOmniBar)();
    const { mode: rovoMode } = (0, $8unJx.useRovoExperienceAPIStore)();
    const isAIMiniModalOpen = rovoMode === 'mini-modal';
    const { handleCommentClick: handleCommentClick } = (0, $a99c3d99e220f083$export$9d7d170793476655)(onCommentClick);
    const { showReactions: showReactions, showComments: showComments } = (0, $be5272beb8fc0b67$export$3ec4f93cedb84cf3)();
    const showCommentButton = showComments && showReactions;
    const { reactionsData: reactionsData, isLoading: reactionsLoading } = (0, $ca2a3913d7f214d1$export$1d9818af02dc36d3)({
        contentId: contentId,
        spaceId: spaceId,
        contentType: contentType,
        skip: !showReactions
    });
    const pageContentDimensions = (0, $aOKRX.usePageContentDimensions)();
    const minContentAreaWidth = 620;
    const shouldHideForSmallViewport = !isSSR && typeof pageContentDimensions.width === 'number' && pageContentDimensions.width > 0 && pageContentDimensions.width <= minContentAreaWidth;
    const isBarVisible = !shouldHideForSmallViewport && showReactions;
    const hasFiredRenderedRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(false);
    (0, $42omo.useEffect)(()=>{
        if (!isBarVisible || hasFiredRenderedRef.current) return;
        hasFiredRenderedRef.current = true;
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'rendered',
                actionSubject: 'omniBar',
                actionSubjectId: 'omniBarRendered',
                source: $3117c19d34064be1$var$OMNIBAR_ANALYTICS_SOURCE
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isBarVisible
    ]);
    const useSSRDimensions = isSSR || !hasHydrated;
    const widthStyle = useSSRDimensions ? '100%' : typeof pageContentDimensions.width === 'number' ? `${pageContentDimensions.width}px` : pageContentDimensions.width;
    const hasValidDimensions = typeof pageContentDimensions.width === 'number' && pageContentDimensions.width > 0;
    const isContainerVisible = typeof pageContentDimensions.width !== 'number' || pageContentDimensions.width > 0;
    (0, $42omo.useEffect)(()=>{
        if (!isContainerVisible) return; // If this was rendered on the server, skip animation on SPA hydration
        if (wasServerRenderedRef.current) return;
        isMountedRef.current = true;
        const frameId = requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (isMountedRef.current) setHasCompletedInitialSlideUp(true);
            });
        });
        return ()=>{
            isMountedRef.current = false;
            cancelAnimationFrame(frameId);
        };
    }, [
        isContainerVisible
    ]);
    const isContainerHiddenForLayoutShift = !isSSR && hasHydrated && typeof pageContentDimensions.width === 'number' && pageContentDimensions.width === 0;
    const leftStyle = !useSSRDimensions && hasValidDimensions && typeof pageContentDimensions.left === 'number' ? `${pageContentDimensions.left}px` : '0px';
    const containerStyle = {
        width: widthStyle,
        left: leftStyle
    };
    const handlePinToggle = (0, $42omo.useCallback)(()=>{
        if (!isPinned) {
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'pinned',
                    actionSubject: 'button',
                    actionSubjectId: 'omniBarPinned',
                    source: $3117c19d34064be1$var$OMNIBAR_ANALYTICS_SOURCE
                }
            }).fire();
            setHideInstantly(true);
            setIsAnimatingOut(false);
            setIsPinned(true);
            $3117c19d34064be1$var$persistPinState(true); // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- intentional rAF to clear hideInstantly after paint
            requestAnimationFrame(()=>setHideInstantly(false));
        } else {
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'unpinned',
                    actionSubject: 'button',
                    actionSubjectId: 'omniBarUnpinned',
                    source: $3117c19d34064be1$var$OMNIBAR_ANALYTICS_SOURCE
                }
            }).fire();
            setIsAnimatingOut(true);
            setIsHovered(false);
            setHasActiveInteraction(false);
            setIsPinned(false);
            $3117c19d34064be1$var$persistPinState(false); // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- intentional delayed reset after unpin animation
            setTimeout(()=>setIsAnimatingOut(false), 200);
        }
    }, [
        isPinned,
        createAnalyticsEvent
    ]);
    const renderIcon = (0, $42omo.useCallback)((iconProps)=>isPinned ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), iconProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))), iconProps), [
        isPinned
    ]);
    const barIsVisible = !shouldHideExternally && !isAIMiniModalOpen && (isPinned && hasCompletedInitialSlideUp || isHovered || hasActiveInteraction); // When bar becomes hidden (unpin or external request), keep content mounted for slide-down animation
    /* eslint-disable @atlassian/perf-linting/no-chain-state-updates -- intentional: deferred setState after 250ms for slide-down animation */ (0, $42omo.useEffect)(()=>{
        if (barIsVisible) {
            barWasVisibleRef.current = true;
            setIsAnimatingOutForUnmount(false);
            return;
        }
        if (barWasVisibleRef.current) {
            barWasVisibleRef.current = false;
            setIsAnimatingOutForUnmount(true);
            const timer = setTimeout(()=>setIsAnimatingOutForUnmount(false), 250);
            return ()=>clearTimeout(timer);
        }
    }, [
        barIsVisible
    ]); /* eslint-enable @atlassian/perf-linting/no-chain-state-updates */ 
    const shouldRenderBarContent = barIsVisible || isAnimatingOutForUnmount;
    if (shouldHideForSmallViewport || !showReactions) return null;
     // Use SSR-matching styles until hydration is complete to prevent mismatches.
    const useSSRStyles = isSSR || !hasHydrated;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        ref: containerRef,
        testId: "omni-bar",
        "data-vc": "omni-bar-container",
        style: containerStyle,
        xcss: (0, $1Whri.cx)($3117c19d34064be1$var$styles.responsiveContainer, shouldHideExternally && $3117c19d34064be1$var$styles.noPointerEvents, isContainerHiddenForLayoutShift && $3117c19d34064be1$var$styles.containerHiddenWhenDimensionsNotReady, useSSRStyles && $3117c19d34064be1$var$styles.ssrContainerStyle),
        onMouseEnter: handleOmniBarMouseEnter,
        onFocus: handleOmniBarMouseEnter,
        onMouseLeave: handleOmniBarMouseLeave,
        onBlur: handleOmniBarMouseLeave
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $3117c19d34064be1$var$styles.responsiveContainerInner
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.100",
        alignBlock: "center",
        xcss: (0, $1Whri.cx)($3117c19d34064be1$var$styles.barContainerBase, $3117c19d34064be1$var$styles.horizontalCenteringFixForToggleButton, (shouldHideInstantly || useSSRStyles) && $3117c19d34064be1$var$styles.barNoTransition, (!isPinned || shouldHideExternally || isAIMiniModalOpen || isPinned && !hasCompletedInitialSlideUp) && $3117c19d34064be1$var$styles.barHidden, !shouldHideInstantly && !shouldHideExternally && !isAIMiniModalOpen && (isPinned && hasCompletedInitialSlideUp || isHovered || hasActiveInteraction) && $3117c19d34064be1$var$styles.barSlideIn)
    }, shouldRenderBarContent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, showReactions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($3117c19d34064be1$var$styles.reactionsContainerBase, $3117c19d34064be1$var$styles.buttonStyle)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $95d3cc090e2e45a6$export$3366148778529365), {
        contentId: contentId,
        spaceId: spaceId,
        contentType: contentType,
        contentSubType: contentSubType,
        reactionsData: reactionsData,
        isLoading: reactionsLoading,
        shouldCloseInteractions: isAnimatingOutForUnmount || shouldHideExternally || isAIMiniModalOpen || !isPinned && !isHovered && !hasActiveInteraction,
        shouldShowBloom: !isAnimatingOutForUnmount && !shouldHideExternally && !isAIMiniModalOpen && (isPinned && hasCompletedInitialSlideUp || isHovered || hasActiveInteraction),
        onInteractionStateChange: setHasActiveInteraction
    })), showCommentButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($3117c19d34064be1$var$styles.commentsContainerBase, $3117c19d34064be1$var$styles.buttonStyle)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        position: "top",
        content: formatMessage($3117c19d34064be1$var$i18n.comment),
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "subtle",
        onClick: handleCommentClick,
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($c6fYi)))
    }, formatMessage($3117c19d34064be1$var$i18n.comment)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($3117c19d34064be1$var$styles.pinContainerBase, isPinned && !isHovered && $3117c19d34064be1$var$styles.pinButtonHiddenWhenNotHovered)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        position: "top",
        content: isPinned ? formatMessage($3117c19d34064be1$var$i18n.hideOmniBar) : formatMessage($3117c19d34064be1$var$i18n.pinOmniBar),
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        shape: "circle",
        icon: renderIcon,
        label: isPinned ? formatMessage($3117c19d34064be1$var$i18n.hideOmniBar) : formatMessage($3117c19d34064be1$var$i18n.pinOmniBar),
        onClick: handlePinToggle
    }))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.VIEW_OMNIBAR_EXPERIENCE)
    }));
};


/**
 * Inner component that provides context data to OmniBar.
 */ const $695c4789ab8d8ace$var$OmniBarWrapperInner = ()=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const { subType: subType } = (0, $9sGCn.getCachedPageData)(contentId);
    if (!contentId || !spaceId || !contentType) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3117c19d34064be1$export$d4fe9bcf0aa84dd5), {
        contentId: contentId,
        spaceId: spaceId,
        contentType: contentType,
        contentSubType: subType
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
        name: (0, $irVI7.VIEW_OMNIBAR_EXPERIENCE),
        attributes: {
            contentId: contentId,
            contentType: contentType
        }
    }));
};
const $695c4789ab8d8ace$export$621326c554b583ec = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).FLYWHEEL_ENGAGEMENT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($695c4789ab8d8ace$var$OmniBarWrapperInner, null));



var $8amSw = parcelRequire("8amSw");


var $6UMDm = parcelRequire("6UMDm");


var $ayQVU = parcelRequire("ayQVU");





var $1kHsc = parcelRequire("1kHsc");





var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


/* eslint-disable confluence-feature-gating/inline-expVal-params */ 



var $ivb8S = parcelRequire("ivb8S");


var $dBcar = parcelRequire("dBcar");

const $586b596f3637df5c$var$COHORT_PARAM = 'cohort';
const $586b596f3637df5c$export$a4a828fdcd26ce47 = (skip = false)=>{
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)([
        (0, $dBcar.ONBOARDING_EXPERIENCES).IS_FOUNDING_ADMIN
    ], skip);
    const { isFoundingAdmin: isFoundingAdmin } = (0, $ivb8S.deserializeState)(onboardingStateData);
    if (skip) return {
        showReactions: false,
        showComments: false
    };
    if (isFoundingAdmin || onboardingStateLoading || onboardingStateError) return {
        showReactions: false,
        showComments: false
    };
    const showReactions = (0, $6mKj3.expValEquals)('cc_engagement_omnibar', $586b596f3637df5c$var$COHORT_PARAM, 'variant_reactions') || (0, $6mKj3.expValEquals)('cc_engagement_omnibar', $586b596f3637df5c$var$COHORT_PARAM, 'variant_reactions_comments') || (0, $6mKj3.expValEquals)('cc_engagement_omnibar_smb', $586b596f3637df5c$var$COHORT_PARAM, 'variant_reactions') || (0, $6mKj3.expValEquals)('cc_engagement_omnibar_smb', $586b596f3637df5c$var$COHORT_PARAM, 'variant_reactions_comments');
    const showComments = (0, $6mKj3.expValEquals)('cc_engagement_omnibar', $586b596f3637df5c$var$COHORT_PARAM, 'variant_reactions_comments') || (0, $6mKj3.expValEquals)('cc_engagement_omnibar_smb', $586b596f3637df5c$var$COHORT_PARAM, 'variant_reactions_comments');
    return {
        showReactions: showReactions,
        showComments: showComments
    };
};



var $aK6zf = parcelRequire("aK6zf");
/* ImportFeedbackBanner.tsx generated by @compiled/babel-plugin v0.36.1 */ 








var $gtD4K = parcelRequire("gtD4K");









var $iXCQx = parcelRequire("iXCQx");





var $hmuev = parcelRequire("hmuev");


var $9FnLD = parcelRequire("9FnLD");


var $9zIwY = parcelRequire("9zIwY");





var $dpPtd = parcelRequire("dpPtd");








var $jQob7 = parcelRequire("jQob7");


var $4mihy = parcelRequire("4mihy");

const $99af38a0b1766526$var$LOCAL_STORAGE_CONTENTID_LIMIT = 200; // 30 bytes per contentId, 200 is 6KB
const $99af38a0b1766526$var$IMPORT_SOURCE_NOTION = 'Notion';
const $99af38a0b1766526$var$translations = (0, $cgtv4.defineMessages)({
    bannerText: {
        id: "import-feedback.banner-text",
        defaultMessage: "This content is imported. How does it look?"
    }
});
const $99af38a0b1766526$var$styles = {
    root: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi"
};
const $99af38a0b1766526$var$unboundedStyles = {
    root: "_1bsb14oa _18u09b24 _kqswh2mm"
};
const $99af38a0b1766526$export$f2bf6e79bf9b9470 = ({ importSource: importSource, importDate: importDate, contentId: contentId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isModalOpen, setIsModalOpen] = (0, $42omo.useState)(false); //TODO (@rwang): Refactor this to use the ImportFeedbackStorageManager (CCIMPORTER-509)
    const [bannerDisabledContentIds, setBannerDisabledContentIds] = (0, $42omo.useState)(()=>JSON.parse((0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_IMPORT_FEEDBACK_DISABLED)) || []);
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'importFeedbackBanner'
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const handleFeedbackClick = ()=>{
        setIsModalOpen(true);
    }; //TODO (@rwang): Refactor this to use the ImportFeedbackStorageManager (CCIMPORTER-509)
    const handleDismissClick = ()=>{
        if (bannerDisabledContentIds.length >= $99af38a0b1766526$var$LOCAL_STORAGE_CONTENTID_LIMIT) bannerDisabledContentIds.shift();
        const updatedIds = [
            ...bannerDisabledContentIds,
            contentId
        ];
        (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_IMPORT_FEEDBACK_DISABLED, JSON.stringify(updatedIds));
        setBannerDisabledContentIds(updatedIds);
    };
    const formattedSource = importSource && $99af38a0b1766526$var$IMPORT_SOURCE_NOTION; // Hardcoded with Notion until backend is updated
    const isFeedbackDisabled = bannerDisabledContentIds.includes(contentId);
    if (isFeedbackDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dpPtd.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-vc": "import-feedback-banner",
        className: (0, $gMc0m.default)([
            $99af38a0b1766526$var$unboundedStyles.root
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($99af38a0b1766526$var$styles.root),
        backgroundColor: "color.background.accent.purple.subtler"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        justifyContent: "space-between",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        gap: "space.400",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        weight: "medium"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $99af38a0b1766526$var$translations.bannerText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9FnLD))),
        label: "Thumbs Up",
        testId: "import-feedback-banner-thumbs-up-button",
        onClick: ()=>{
            (0, $4mihy.submitSurveyFeedback)(createAnalyticsEvent, 'importedPageFeedbackBanner', formattedSource, importDate, contentId, 'positive');
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'thumsUpButton',
                    actionSubjectId: 'importFeedbackSurvey',
                    source: 'importedPageFeedbackBanner'
                }
            }).fire();
            handleDismissClick();
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9zIwY))),
        label: "Thumbs Down",
        testId: "import-feedback-banner-thumbs-down-button",
        onClick: ()=>{
            handleFeedbackClick();
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'thumsDownButton',
                    actionSubjectId: 'importFeedbackSurvey',
                    source: 'importedPageFeedbackBanner'
                }
            }).fire();
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
        label: "Close",
        testId: "import-feedback-banner-close-button",
        onClick: ()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'dismissButton',
                    actionSubjectId: 'importFeedbackSurvey',
                    source: 'importedPageFeedbackBanner'
                }
            }).fire();
            handleDismissClick();
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jQob7.FeedbackModal), {
        isOpen: isModalOpen,
        closeModal: ()=>setIsModalOpen(false),
        importSource: formattedSource,
        importDate: importDate,
        contentId: contentId,
        onFeedbackSubmit: handleDismissClick
    })));
};



var $4yKPM = parcelRequire("4yKPM");


var $hq2Sz = parcelRequire("hq2Sz");


var $kZEms = parcelRequire("kZEms");


var $8tF9d = parcelRequire("8tF9d");



var $cmBjr = parcelRequire("cmBjr");


var $gGHFp = parcelRequire("gGHFp");


var $lfmjq = parcelRequire("lfmjq");


var $83sfO = parcelRequire("83sfO");


var $3jwuS = parcelRequire("3jwuS");


var $efvKr = parcelRequire("efvKr");


var $398ES = parcelRequire("398ES");


var $hdxAi = parcelRequire("hdxAi");


var $cMKmt = parcelRequire("cMKmt");


var $1NBp8 = parcelRequire("1NBp8");


var $2VZOl = parcelRequire("2VZOl");


var $2xS8W = parcelRequire("2xS8W");


var $70pcM = parcelRequire("70pcM");


var $lrMxq = parcelRequire("lrMxq");


var $3oWMY = parcelRequire("3oWMY");


var $3WPGR = parcelRequire("3WPGR");


var $fIKxq = parcelRequire("fIKxq");


var $jXhAV = parcelRequire("jXhAV");


var $fSC8h = parcelRequire("fSC8h");


var $8WQTF = parcelRequire("8WQTF");


var $kJNMt = parcelRequire("kJNMt");





var $60cDW = parcelRequire("60cDW");


var $78QFu = parcelRequire("78QFu");


var $eSLr0 = parcelRequire("eSLr0");


var $juCeZ = parcelRequire("juCeZ");

/* NthUserOnboardingBannerComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 































var $4PPzL = parcelRequire("4PPzL");


var $2YJkl = parcelRequire("2YJkl");








var $bZSO8 = parcelRequire("bZSO8");




const $90ee5598e42d1e39$export$2f4bef5ac2235525 = ({ size: size = 24 })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M40.5834 12.4787V11.4679C40.5834 10.4416 39.7509 9.60904 38.7245 9.60904C37.6982 9.60904 36.8656 10.4416 36.8656 11.4679L36.8655 34.6931H40.5152V22.447C40.7101 22.3333 40.8416 22.1221 40.8416 21.8797V12.4787H40.5834Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M36.8672 33.2949H40.517V36.517C40.517 37.5241 39.6983 38.3427 38.6912 38.3427C37.6841 38.3427 36.8655 37.5241 36.8655 36.517V33.2949H36.8672Z",
        fill: "#09326C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M40.0841 12.5274H39.5291V19.5895H40.0841V12.5274Z",
        fill: "#09326C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M30.1165 14.1508L31.4722 10.131L32.8278 14.1508H32.8301V37.264H31.9225V38.2101H30.973V37.264H30.116V14.1508H30.1165Z",
        fill: "#292A2E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M26.0772 14.732H22.4275V38.4405H26.0772V14.732Z",
        fill: "#FCA700"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M26.4852 36.997H22.0186V38.5854H26.4852V36.997Z",
        fill: "#BF63F3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M26.0772 36.997H22.4275V38.4405H26.0772V36.997Z",
        fill: "#AE2A19"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M23.4919 9.84648H25.0122V10.8868H26.8518L26.3526 16.3797H22.1635L21.666 10.8868H23.4919V9.84648Z",
        fill: "#BF63F3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M26.0772 14.7145H22.4275V16.3797H26.0772V14.7145Z",
        fill: "#AE2A19"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M16.0303 10.5813V9.92496L17.1003 9.52176V10.5813H17.3271V11.9173C17.9504 12.208 18.3832 12.8407 18.3832 13.573V16.4634H18.3812V38.4405H14.7314V15.8194H14.7335V13.573C14.7335 12.8415 15.1653 12.2094 15.7876 11.9183V10.5813H16.0303Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M13.9373 26.2204C13.6598 26.3984 13.7331 26.5782 14.0438 26.4298C14.152 26.3774 14.262 26.3233 14.3754 26.2675C14.4802 26.2134 14.5884 26.1593 14.7123 26.1069C14.9532 26.0004 15.2098 25.8852 15.5013 25.7735C15.8294 25.6426 16.0354 25.5815 16.2186 25.5396C16.4002 25.4977 16.5608 25.4803 16.7842 25.5117C16.9727 25.5379 17.1821 25.6182 17.3637 25.7613C17.4056 25.7997 17.4492 25.8398 17.4928 25.88C17.533 25.9219 17.5644 25.9655 17.5993 26.0092C17.6569 26.1034 17.704 26.2029 17.7285 26.3111C",
        fill: "#164B35"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M14.0262 24.3566C13.918 24.5207 14.0838 24.6272 14.2078 24.5067C14.3963 24.3304 14.5918 24.1349 14.8291 23.8731C15.091 23.5694 15.1294 23.4699 15.3161 23.2709C15.6268 22.9323 16.1923 22.3982 16.3285 22.2708C16.3494 22.2516 16.3686 22.2324 16.3861 22.2115C16.5153 22.0613 17.0825 21.4033 17.6027 20.864C17.9622 20.4765 18.1839 20.2356 18.2991 20.1117C18.5732 19.8149 18.7634 19.5811 18.9362 19.3349C19.0392 19.1883 18.8961 19.0941 18.7809 19.1936C18.5557 19.3856 18.334 19.5933 18.06 19.8883C",
        fill: "#164B35"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M14.042 19.7396C13.9285 19.8495 14.0594 19.9944 14.1816 19.9298C14.3614 19.8356 14.5534 19.7291 14.7873 19.5773C15.0491 19.3957 15.0945 19.3189 15.2778 19.2072C15.585 19.01 16.133 18.7272 16.2657 18.6591C16.2849 18.6487 16.3041 18.6382 16.3215 18.626C16.4507 18.5352 17.018 18.1425 17.5276 17.8388C17.882 17.6154 18.1019 17.4775 18.2171 17.4042C18.4876 17.2314 18.6796 17.0882 18.8594 16.9294C18.9676 16.8317 18.8542 16.706 18.746 16.7531C18.5295 16.8491 18.3166 16.9591 18.0443 17.1284C17.9",
        fill: "#164B35"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M17.102 10.5813H16.0303V11.5343H17.102V10.5813Z",
        fill: "#09326C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M7.51953 14.1734L9.34528 9.4258L11.1693 14.1734H7.51953Z",
        fill: "#FCA700"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M7.51953 14.1734H11.1693V34.693H7.51953V14.1734Z",
        fill: "#FCA700"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M7.51957 33.2949H11.1693V36.517C11.1693 37.5241 10.3507 38.3427 9.34357 38.3427C8.33644 38.3427 7.51782 37.5241 7.51782 36.517V33.2949H7.51957Z",
        fill: "#BF63F3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M9.99599 11.1206L9.34494 9.4258L8.69214 11.1206H9.99599Z",
        fill: "#292A2E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M11.5339 33.1553H7.15625V34.8309H11.5339V33.1553Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M11.1693 33.1553H7.51953V34.8309H11.1693V33.1553Z",
        fill: "#164B35"
    }));
};


/**
 * @graphql cc
 */ 



var $eSUdr = parcelRequire("eSUdr");





var $1uFM6 = parcelRequire("1uFM6");


var $7LI3Q = parcelRequire("7LI3Q");


var $5cryL = parcelRequire("5cryL");













var $7Sm4c = parcelRequire("7Sm4c");


var $jNGt9 = parcelRequire("jNGt9");

// Mappings from team type to blueprint key
var $7c2911d3d6072871$export$3e5d0af8e738b082 = /*#__PURE__*/ function(Team) {
    Team["ProductManagement"] = "Product management";
    Team["Marketing"] = "Marketing";
    Team["Design"] = "Design";
    Team["ProjectManagement"] = "Project management";
    Team["Operations"] = "Operations";
    Team["ITSupport"] = "IT support";
    Team["Finance"] = "Finance";
    Team["HumanResources"] = "Human resources";
    Team["Legal"] = "Legal";
    Team["Sales"] = "Sales";
    Team["SoftwareDevelopment"] = "Software development";
    Team["Default"] = "default";
    return Team;
}({});
const $7c2911d3d6072871$export$9be36dcb0276df0e = {
    ["Product management"]: 'com.atlassian.confluence.plugins.confluence-software-blueprints:requirements-blueprint',
    ["Marketing"]: 'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-campaign-blueprint',
    ["Design"]: 'com.atlassian.confluence.plugins.confluence-business-blueprints:design-decision-blueprint',
    ["Project management"]: 'com.atlassian.confluence.plugins.confluence-business-blueprints:projectplan-blueprint',
    ["Operations"]: 'com.atlassian.confluence.plugins.confluence-business-blueprints:standard-operating-procedure-sop-blueprint',
    ["IT support"]: 'com.atlassian.confluence.plugins.confluence-knowledge-base:kb-how-to-article-blueprint',
    ["Finance"]: 'com.atlassian.confluence.plugins.confluence-business-blueprints:business-status-update-blueprint',
    ["Human resources"]: 'com.atlassian.confluence.plugins.confluence-business-blueprints:employee-handbook-blueprint',
    ["Legal"]: 'com.atlassian.confluence.plugins.confluence-business-blueprints:projectplan-blueprint',
    ["Sales"]: 'com.atlassian.confluence.plugins.confluence-business-blueprints:business-strategy-blueprint',
    ["Software development"]: 'flowchart',
    ["default"]: ''
};


function $d7f916a38b1d31f2$export$8715824c16ceeca0(error) {
    return (0, $1uFM6.isUnauthorizedError)(error) || (0, $7LI3Q.isUnauthorizedError)(error);
}
const $d7f916a38b1d31f2$export$f801dddbfe4eaae5 = ({ contentID: contentID })=>{
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { data: onboardingStateData, loading: isOnboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)([
        (0, $dBcar.ONBOARDING_EXPERIENCES).NTH_USER_BANNER_DISMISSED,
        (0, $dBcar.ONBOARDING_EXPERIENCES).IMPROVED_GET_STARTED_NTH_USER_PATH,
        (0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS).HAS_USER_PUBLISHED
    ]);
    const { hasUserPublished: hasUserPublished, nthUserGSPagePath: nthUserGSPagePath, nthUserBannerDismissed: nthUserBannerDismissed } = (0, $ivb8S.deserializeState)(onboardingStateData);
    const isCorrectContentId = nthUserGSPagePath && (0, $jNGt9.extractContentIdFromUrl)(nthUserGSPagePath) === contentID;
    // Skip all side effects if user is not eligible
    const isUserEligible = !isOnboardingStateLoading && !onboardingStateError && !nthUserBannerDismissed && !hasUserPublished && nthUserGSPagePath && isCorrectContentId;
    // Query to get the team type of the user from identity service
    const { data: data, loading: isTeamTypeLoading, error: teamTypeError } = (0, $jMyy4.useQueryInterop)(// @ts-expect-error -- http://go/cfe-use-relay-artifacts
    (0, $eSUdr.gql)`query useNthUserOnboardingBannerGetTeamTypeQuery($userId:ID!){user:confluence_atlassianUser(id:$userId){team}}`, {
        variables: {
            userId: userId ?? ''
        },
        skip: !userId || !isUserEligible
    });
    const teamType = data?.user?.team;
    (0, $42omo.useEffect)(()=>{
        if (!isUserEligible) return;
        if (teamTypeError && $d7f916a38b1d31f2$export$8715824c16ceeca0(teamTypeError)) (0, $7Sm4c.markErrorAsHandled)(teamTypeError);
        else if (teamTypeError) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: 'nthUserGSPage',
                actionSubject: 'teamTypeFetching',
                action: 'failed',
                actionSubjectId: 'nthUserOnboardingBanner',
                attributes: {
                    error: teamTypeError?.message || teamTypeError || 'Unknown error'
                }
            }
        }).fire();
    }, [
        teamTypeError,
        createAnalyticsEvent,
        isUserEligible
    ]);
    // Query to get the template info from the blueprint key
    const blueprintKey = (0, $7c2911d3d6072871$export$9be36dcb0276df0e)[teamType ?? (0, $7c2911d3d6072871$export$3e5d0af8e738b082).Default];
    const { data: templateData, loading: isTemplateLoading, error: templateError } = (0, $jMyy4.useQueryInterop)(// @ts-expect-error -- http://go/cfe-use-relay-artifacts
    (0, $eSUdr.gql)`query useNthUserOnboardingBannerGetTemplateInfoQuery($blueprintKey:ID!){templateInfo(id:$blueprintKey){name templateType contentBlueprintId blueprintModuleCompleteKey itemModuleCompleteKey}}`, {
        variables: {
            blueprintKey: blueprintKey
        },
        skip: !blueprintKey || !isUserEligible || teamType === (0, $7c2911d3d6072871$export$3e5d0af8e738b082).SoftwareDevelopment
    });
    (0, $42omo.useEffect)(()=>{
        if (!isUserEligible) return;
        if (templateError && $d7f916a38b1d31f2$export$8715824c16ceeca0(templateError)) (0, $7Sm4c.markErrorAsHandled)(templateError);
        else if (templateError) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: 'nthUserGSPage',
                actionSubject: 'templateFetching',
                action: 'failed',
                actionSubjectId: 'nthUserOnboardingBanner',
                attributes: {
                    error: templateError?.message || templateError || 'Unknown error'
                }
            }
        }).fire();
    }, [
        templateError,
        createAnalyticsEvent,
        isUserEligible
    ]);
    const { templateInfo: templateInfo } = templateData || {};
    const { name: templateName } = templateInfo || {};
    const blueprintName = (0, $42omo.useMemo)(()=>{
        if (!isUserEligible) return '';
        if (teamType === (0, $7c2911d3d6072871$export$3e5d0af8e738b082).SoftwareDevelopment) return blueprintKey;
        if (teamType === (0, $7c2911d3d6072871$export$3e5d0af8e738b082).Operations) return 'standard operating procedure';
        return (templateName ?? '').toLowerCase();
    }, [
        isUserEligible,
        teamType,
        templateName,
        blueprintKey
    ]);
    const isLoading = isTeamTypeLoading || isTemplateLoading;
    return {
        isUserEligible: isUserEligible,
        isLoading: isLoading,
        blueprintName: blueprintName,
        teamType: teamType,
        templateToCreate: templateInfo
    };
};



const $627671e2381ceaa8$var$roundedBoxStyles = {
    root: "_2rko1mok _1yt4u2gc _1h6dvbh5 _16qst7xp _1bsb1osq _p12f9gu9"
};
const $627671e2381ceaa8$var$observerStyles = {
    root: "_4t3it94y _1bsb1osq _3um015vq _lcxvglyw"
};
const $627671e2381ceaa8$var$outerContainerStyles = {
    root: "_1e0c1txw _1bah1h6o"
};
const $627671e2381ceaa8$var$innerContainerStyles = {
    locked: "_kqswh2mm _lcxv1wug _1e0c1txw _1bah1h6o _1bsb1osq _otyrpxbi _19pkpxbi",
    floating: "_kqsw1n9t _94n5pxbi _lcxv1wug _1e0c1txw _1bah1h6o _1bsb1osq _otyru2gc"
};
const $627671e2381ceaa8$var$linkPressableStyles = {
    root: "_19itglyw _1yt4ze3t _bfhk19ip _80omtlke _9oik1r31 _1bnx8stv _jf4cnqa1 _30l313af"
};
const $627671e2381ceaa8$var$i18n = (0, $cgtv4.defineMessages)({
    nthUserOnboardingBannerTitle: {
        id: "experiment-nth-user-getting-started-page.nth-user-onboarding.banner.title",
        defaultMessage: "Next up: start creating"
    },
    nthUserOnboardingBannerAction: {
        id: "experiment-nth-user-getting-started-page.nth-user-onboarding.banner.action",
        defaultMessage: "Try a {blueprintName} template"
    },
    nthUserOnboardingBannerActionFallback: {
        id: "experiment-nth-user-getting-started-page.nth-user-onboarding.banner.action-fallback",
        defaultMessage: "Create a page"
    },
    nthUserOnboardingBannerDismiss: {
        id: "experiment-nth-user-getting-started-page.nth-user-onboarding.banner.dismiss",
        defaultMessage: "Dismiss"
    }
});
const $627671e2381ceaa8$var$DELAY_TIMEOUT = 8000;
const $627671e2381ceaa8$var$NthUserOnboardingBannerComponentInternal = ({ contentID: contentID, spaceKey: spaceKey })=>{
    const [isVisible, setIsVisible] = (0, $42omo.useState)(false);
    const [isLocked, setIsLocked] = (0, $42omo.useState)(false);
    const observerRef = (0, $42omo.useRef)(null);
    const intersectionObserverRef = (0, $42omo.useRef)(null);
    const isLockedRef = (0, $42omo.useRef)(false);
    const hasBeenTriggered = (0, $42omo.useRef)(false);
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const createContentFromTemplate = (0, $2YJkl.useCreateContentFromTemplate)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { isUserEligible: isUserEligible, isLoading: isLoading, blueprintName: blueprintName, teamType: teamType, templateToCreate: templateToCreate } = (0, $d7f916a38b1d31f2$export$f801dddbfe4eaae5)({
        contentID: contentID
    }); // Show banner after delay
    (0, $42omo.useEffect)(()=>{
        if (!isUserEligible) return;
        isLockedRef.current = isLocked;
        const delayTimeout = setTimeout(()=>{
            setIsVisible(true);
            createAnalyticsEvent({
                type: 'sendScreenEvent',
                data: {
                    name: 'viewNthUserOnboardingBanner'
                }
            }).fire();
        }, $627671e2381ceaa8$var$DELAY_TIMEOUT);
        return ()=>clearTimeout(delayTimeout);
    }, [
        isUserEligible,
        isLocked,
        createAnalyticsEvent
    ]); // Intersection observer for banner positioning
    (0, $42omo.useEffect)(()=>{
        if (!isVisible || !isUserEligible) return;
        const targetElement = observerRef.current;
        if (!targetElement) return;
        let pollInterval = null;
        const checkPosition = ()=>{
            const targetRect = targetElement.getBoundingClientRect();
            const isTargetWellBelowViewport = targetRect.top > window.innerHeight + 100;
            if (isTargetWellBelowViewport && isLockedRef.current) {
                setIsLocked(false);
                hasBeenTriggered.current = false;
                if (pollInterval) {
                    clearInterval(pollInterval);
                    pollInterval = null;
                }
            }
        };
        const handleIntersection = (entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting && !hasBeenTriggered.current) {
                    setIsLocked(true);
                    hasBeenTriggered.current = true;
                    pollInterval = setInterval(checkPosition, 100);
                }
            });
        };
        intersectionObserverRef.current = new IntersectionObserver(handleIntersection, {
            root: null,
            rootMargin: '0px',
            threshold: 0
        });
        intersectionObserverRef.current.observe(targetElement);
        return ()=>{
            if (intersectionObserverRef.current) intersectionObserverRef.current.disconnect();
            if (pollInterval) clearInterval(pollInterval);
        };
    }, [
        isVisible,
        isUserEligible
    ]);
    const handleDismiss = (0, $42omo.useCallback)(()=>{
        setIsVisible(false);
        setOnboardingState({
            key: (0, $dBcar.ONBOARDING_EXPERIENCES).NTH_USER_BANNER_DISMISSED,
            value: 'true'
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'nthUserGSPage',
                action: 'dismissed',
                actionSubject: 'banner',
                actionSubjectId: 'nthUserOnboardingBanner'
            }
        }).fire();
    }, [
        setOnboardingState,
        createAnalyticsEvent
    ]);
    const handleTemplateClick = (0, $42omo.useCallback)(()=>{
        try {
            if (spaceKey) {
                if (templateToCreate) createContentFromTemplate(templateToCreate, spaceKey, {
                    openContentInNewTab: true
                });
                else if (teamType === (0, $7c2911d3d6072871$export$3e5d0af8e738b082).SoftwareDevelopment) {
                    // If the user is in a software development team, we need to create a flowchart template - separate flow
                    const softwareTemplateCreationLink = (0, $bZSO8.buildCreationLink)({
                        contentType: 'whiteboard',
                        source: 'nthUserOnboardingBanner',
                        spaceKey: spaceKey,
                        insertTemplateWithKey: 'flow-chart',
                        openTemplatePicker: false
                    });
                    window.open(softwareTemplateCreationLink, '_blank');
                } else {
                    // default to create a blank page - no team type or template available
                    const createUrl = (0, $bZSO8.buildCreationLink)({
                        contentType: 'page',
                        source: 'nthUserOnboardingBanner',
                        spaceKey: spaceKey
                    });
                    window.open(createUrl, '_blank');
                }
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        source: 'nthUserGSPage',
                        action: 'clicked',
                        actionSubject: 'banner',
                        actionSubjectId: 'nthUserOnboardingBanner'
                    }
                }).fire();
            }
            handleDismiss();
        } catch (error) {
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    source: 'nthUserGSPage',
                    action: 'failed',
                    actionSubject: 'template creation',
                    actionSubjectId: 'nthUserOnboardingBanner',
                    attributes: {
                        error: error?.message || error || 'Unknown error'
                    }
                }
            }).fire();
            handleDismiss();
        }
    }, [
        createContentFromTemplate,
        createAnalyticsEvent,
        handleDismiss,
        spaceKey,
        templateToCreate,
        teamType
    ]);
    if (!isVisible || !isUserEligible || isLoading) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        ref: observerRef,
        xcss: $627671e2381ceaa8$var$observerStyles['root']
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $627671e2381ceaa8$var$outerContainerStyles['root'],
        "data-vc": "page-layout-nth-user-onboarding-banner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $627671e2381ceaa8$var$innerContainerStyles[isLocked ? 'locked' : 'floating']
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $627671e2381ceaa8$var$roundedBoxStyles['root'],
        backgroundColor: "color.background.information"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        justifyContent: "space-between",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        alignItems: "center",
        gap: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $90ee5598e42d1e39$export$2f4bef5ac2235525), {
        size: 50
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        weight: "bold"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $627671e2381ceaa8$var$i18n.nthUserOnboardingBannerTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        alignItems: "center",
        gap: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
        onClick: handleTemplateClick,
        xcss: $627671e2381ceaa8$var$linkPressableStyles['root']
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.link"
    }, blueprintName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...$627671e2381ceaa8$var$i18n.nthUserOnboardingBannerAction,
        values: {
            blueprintName: blueprintName
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $627671e2381ceaa8$var$i18n.nthUserOnboardingBannerActionFallback))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        onClick: handleDismiss,
        appearance: "subtle",
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), iconProps),
        label: formatMessage($627671e2381ceaa8$var$i18n.nthUserOnboardingBannerDismiss),
        isTooltipDisabled: false
    })))))));
};
const $627671e2381ceaa8$export$a4224605ab1026cb = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).FLYWHEEL_ENGAGEMENT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($627671e2381ceaa8$var$NthUserOnboardingBannerComponentInternal, props));




















const $bd6002357c1db080$export$d42c6c42be666145 = ({ contentId: contentId = '', skip: skip = false } = {})=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { data: onboardingStateData, error: onboardingStateError, loading: onboardingStateLoading } = (0, $ivb8S.useGetOnboardingState)([
        (0, $dBcar.ONBOARDING_EXPERIENCES).IMPROVED_GET_STARTED_NTH_USER_PATH,
        (0, $dBcar.ONBOARDING_EXPERIENCES).NTH_USER_ONBOARDING_PAGE_VIEWED
    ], skip);
    const deserializedState = (0, $ivb8S.deserializeState)(onboardingStateData);
    const nthUserOnboardingPageViewed = deserializedState[0, $dBcar.NTH_USER_ONBOARDING_PAGE_VIEWED];
    const nthUserGSPage = deserializedState[0, $dBcar.IMPROVED_GET_STARTED_NTH_USER_PATH];
    (0, $42omo.useEffect)(()=>{
        if (skip || !(0, $9wGTI.fg)('cc-engagement-getting-started-nth-user-gate')) return;
        if (!onboardingStateData || onboardingStateError || onboardingStateLoading) return;
        if (nthUserGSPage && (0, $jNGt9.extractContentIdFromUrl)(nthUserGSPage) === contentId) {
            if (!nthUserOnboardingPageViewed) {
                createAnalyticsEvent({
                    type: 'sendScreenEvent',
                    data: {
                        name: 'NthUserGettingStartedPage'
                    }
                }).fire();
                setOnboardingState({
                    key: (0, $dBcar.ONBOARDING_EXPERIENCES).NTH_USER_ONBOARDING_PAGE_VIEWED,
                    value: 'true'
                });
            }
        }
    }, [
        contentId,
        createAnalyticsEvent,
        onboardingStateData,
        onboardingStateError,
        onboardingStateLoading,
        nthUserGSPage,
        nthUserOnboardingPageViewed,
        setOnboardingState,
        skip
    ]);
};












var $JCGnt = parcelRequire("JCGnt");


const $4d7d073c1c91ca91$var$useLazyAmplitudeInit = ()=>{
    return (0, $42omo.useCallback)(async ()=>{
        if (!(0, $9wGTI.fg)('cc_engagement_amplitude_session_replay_gate')) return; // no-op
        const module = await (parcelRequire("3ql08"));
        return module.AmplitudeSessionReplay.init();
    }, []);
};

const $4d7d073c1c91ca91$var$useLazyAmplitudeStop = ()=>{
    return (0, $42omo.useCallback)(async ()=>{
        if (!(0, $9wGTI.fg)('cc_engagement_amplitude_session_replay_gate')) return; // no-op
        const module = await (parcelRequire("3ql08"));
        return module.AmplitudeSessionReplay.stop();
    }, []);
};
const $4d7d073c1c91ca91$export$7ac5f7e6449ca924 = ({ skip: skip = false, timeoutMs: timeoutMs = 180000 // 3 minutes default
 } = {})=>{
    const amplitudeInit = $4d7d073c1c91ca91$var$useLazyAmplitudeInit();
    const amplitudeStop = $4d7d073c1c91ca91$var$useLazyAmplitudeStop();
    const timeoutRef = (0, $42omo.useRef)();
    const isInitializedRef = (0, $42omo.useRef)(false);
    const analyticsEventFiredRef = (0, $42omo.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isNewUser: isNewUser, loading: isLoadingNewUser } = (0, $JCGnt.useIsNewUser)({}, skip || !(0, $9wGTI.fg)('cc_engagement_amplitude_session_replay_gate'));
    (0, $42omo.useEffect)(()=>{
        if (skip || !(0, $9wGTI.fg)('cc_engagement_amplitude_session_replay_gate')) return;
        // Initialize amplitude
        amplitudeInit();
        isInitializedRef.current = true;
        // Set timeout to stop after specified time
        timeoutRef.current = setTimeout(()=>{
            amplitudeStop();
            isInitializedRef.current = false;
        }, timeoutMs);
        // Cleanup function
        return ()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
            if (isInitializedRef.current) {
                amplitudeStop();
                isInitializedRef.current = false;
            }
        };
    }, [
        skip,
        amplitudeInit,
        amplitudeStop,
        timeoutMs
    ]);
    (0, $42omo.useEffect)(()=>{
        if (skip || !(0, $9wGTI.fg)('cc_engagement_amplitude_session_replay_gate') || !isInitializedRef.current || analyticsEventFiredRef.current || isLoadingNewUser) return;
        if (isNewUser) {
            //Use this analytics event to add extra attributes so it can be filtered in Amplitude
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'triggered',
                    actionSubject: 'amplitudeSessionReplay',
                    source: 'confluenceAmplitudeSessionReplay',
                    attributes: {
                        isNewUser: true
                    }
                }
            }).fire();
            analyticsEventFiredRef.current = true;
        }
    }, [
        skip,
        isNewUser,
        createAnalyticsEvent,
        isLoadingNewUser
    ]);
    // Cleanup effect that always runs on unmount
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
            if (isInitializedRef.current) {
                amplitudeStop();
                isInitializedRef.current = false;
            }
        };
    }, [
        amplitudeStop
    ]);
    // Handle pagehide to stop amplitude session replay when page closes
    (0, $42omo.useEffect)(()=>{
        if (skip || !(0, $9wGTI.fg)('cc_engagement_amplitude_session_replay_gate')) return;
        const handlePageHide = ()=>{
            if (isInitializedRef.current) {
                amplitudeStop();
                isInitializedRef.current = false;
            }
        };
        window.addEventListener('pagehide', handlePageHide);
        return ()=>{
            window.removeEventListener('pagehide', handlePageHide);
        };
    }, [
        skip,
        amplitudeStop
    ]);
};






const $cfdf4590bc9d9b83$export$f9de7c50725ea941 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "odo_M",
    name: "TeammateContentRecommendationBanner",
    loader: async ()=>(await (parcelRequire("jGkfy"))).TeammateContentRecommendationBanner
});



var $dGhsu = parcelRequire("dGhsu");








var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");

const $f7fdcf7379ee3b47$var$dividerStyles = (0, $ecnYn.xcss)({
    width: '100%',
    display: 'flex',
    borderBottomWidth: 'border.width',
    borderBottomStyle: 'solid',
    borderColor: 'color.border'
});
const $f7fdcf7379ee3b47$export$2e0a83ec2e27ecbb = (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { testId: testId } = t0;
    let t1;
    if ($[0] !== testId) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $f7fdcf7379ee3b47$var$dividerStyles,
            testId: testId
        });
        $[0] = testId;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};






const $889eab36c217c00c$export$bdd4a5944172b352 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "kTgHc",
    name: "SatisfactionSurveysLoader",
    loader: async ()=>(await (parcelRequire("8E6no"))).SatisfactionSurveys
});



var $aXika = parcelRequire("aXika");











var $j1Ss3 = parcelRequire("j1Ss3");


var $6GD8y = parcelRequire("6GD8y");


var $gnkil = parcelRequire("gnkil");


var $04e9M = parcelRequire("04e9M");


var $dPJCf = parcelRequire("dPJCf");


var $2i3To = parcelRequire("2i3To");








var $isEtk = parcelRequire("isEtk");





var $deTj5 = parcelRequire("deTj5");


var $7zgzO = parcelRequire("7zgzO");


var $hrEV9 = parcelRequire("hrEV9");





var $aJv6Q = parcelRequire("aJv6Q");





var $ftXPY = parcelRequire("ftXPY");


var $aWwYt = parcelRequire("aWwYt");


var $jvYFk = parcelRequire("jvYFk");




const $1f8c76250771e531$var$pageCommentWrapperStyles = null;
const $1f8c76250771e531$var$sendKeyboardShortcutAnalytics = (shortcut)=>{
    (0, $04e9M.getAnalyticsWebClient)().then((analyticsClient)=>{
        analyticsClient.sendUIEvent({
            source: 'viewPage',
            action: 'pressed',
            actionSubject: 'keyboardShortcut',
            actionSubjectId: 'createComment',
            attributes: {
                key: shortcut
            }
        });
    });
}; /**
    * @deprecated This component is deprecated and will be removed in a future version.
    * It is used to render legacy page comments but is no longer needed as part of modernization.
    */ 
const $1f8c76250771e531$var$LazyLoadablePageComments = (t0)=>{
    const $ = (0, $frIzR.c)(28);
    const { children: children, isContentReady: isContentReady, shouldLazyLoad: shouldLazyLoad, renderPlaceholder: t1, loadPageCommentsCallback: t2, isCommentsReady: isCommentsReady, totalCount: totalCount } = t0;
    const renderPlaceholder = t1 === undefined ? undefined : t1;
    const loadPageCommentsCallback = t2 === undefined ? undefined : t2;
    const wrapperRef = (0, $42omo.useRef)(null);
    const observerRef = (0, $42omo.useRef)(null);
    const [loadPageComments, setLoadPageComments] = (0, $42omo.useState)(!shouldLazyLoad);
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const panel = (0, $aWwYt.usePanel)();
    const isCommentsPanelShown = isObjectSidebarShown && panel?.id === (0, $jvYFk.PanelName).CommentsPanel;
    const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (Boolean(undefined) || window.__SSR_RENDERED__) && (0, $9wGTI.fg)("confluence_frontend_remove_comments_placeholder");
        $[0] = t3;
    } else t3 = $[0];
    const isCommentPreloadedForSSR = t3;
    let t4;
    let t5;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>{
            observerRef.current = new IntersectionObserver((t6)=>{
                const [entry] = t6;
                if (entry.isIntersecting) {
                    setLoadPageComments(true);
                    observerRef.current?.disconnect();
                }
            });
            return ()=>{
                observerRef.current?.disconnect();
            };
        };
        t5 = [];
        $[1] = t4;
        $[2] = t5;
    } else {
        t4 = $[1];
        t5 = $[2];
    }
    (0, $42omo.useEffect)(t4, t5);
    let t6;
    let t7;
    if ($[3] !== isContentReady || $[4] !== loadPageComments) {
        t6 = ()=>{
            if (wrapperRef.current && !loadPageComments && isContentReady) observerRef.current?.observe(wrapperRef.current);
        };
        t7 = [
            loadPageComments,
            isContentReady
        ];
        $[3] = isContentReady;
        $[4] = loadPageComments;
        $[5] = t6;
        $[6] = t7;
    } else {
        t6 = $[5];
        t7 = $[6];
    }
    (0, $42omo.useEffect)(t6, t7);
    let t8;
    let t9;
    if ($[7] !== loadPageComments || $[8] !== loadPageCommentsCallback) {
        t8 = ()=>{
            if (loadPageComments) loadPageCommentsCallback?.();
        };
        t9 = [
            loadPageComments,
            loadPageCommentsCallback
        ];
        $[7] = loadPageComments;
        $[8] = loadPageCommentsCallback;
        $[9] = t8;
        $[10] = t9;
    } else {
        t8 = $[9];
        t9 = $[10];
    }
    (0, $42omo.useEffect)(t8, t9);
    let t10;
    if ($[11] !== isCommentsPanelShown || $[12] !== loadPageComments) {
        t10 = loadPageComments || isCommentsPanelShown && (0, $9wGTI.fg)("confluence_frontend_content_wrapper");
        $[11] = isCommentsPanelShown;
        $[12] = loadPageComments;
        $[13] = t10;
    } else t10 = $[13];
    const shouldRenderPageComments = t10;
    let t11;
    if ($[14] !== isCommentsReady || $[15] !== setQueryParams) {
        t11 = (e)=>{
            e.preventDefault();
            const shortcut = e.key === (0, $gnkil.CREATE_COMMENT_SHORTCUT) ? (0, $gnkil.CREATE_COMMENT_SHORTCUT) : (0, $gnkil.UNIVERSAL_OPEN_COMMENT_EDITOR);
            if (!isCommentsReady) {
                setQueryParams({
                    showCommentArea: "true"
                });
                wrapperRef.current?.scrollIntoView && wrapperRef.current?.scrollIntoView();
            } else window.dispatchEvent(new Event("openPageCommentEditor"));
            $1f8c76250771e531$var$sendKeyboardShortcutAnalytics(shortcut);
        };
        $[14] = isCommentsReady;
        $[15] = setQueryParams;
        $[16] = t11;
    } else t11 = $[16];
    const openCommentEditorShortcutCb = t11;
    let t12;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = (0, $gMc0m.default)([
            "_kqswh2mm _1pbyidpf"
        ]);
        $[17] = t12;
    } else t12 = $[17];
    let t13;
    if ($[18] !== openCommentEditorShortcutCb) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
            deprecatedAccelerator: (0, $gnkil.CREATE_COMMENT_SHORTCUT),
            accelerator: (0, $gnkil.UNIVERSAL_OPEN_COMMENT_EDITOR),
            listener: (e_0)=>openCommentEditorShortcutCb(e_0)
        });
        $[18] = openCommentEditorShortcutCb;
        $[19] = t13;
    } else t13 = $[19];
    let t14;
    if ($[20] !== children || $[21] !== renderPlaceholder || $[22] !== shouldRenderPageComments || $[23] !== totalCount) {
        t14 = isCommentPreloadedForSSR && totalCount === 0 || shouldRenderPageComments ? children : renderPlaceholder?.();
        $[20] = children;
        $[21] = renderPlaceholder;
        $[22] = shouldRenderPageComments;
        $[23] = totalCount;
        $[24] = t14;
    } else t14 = $[24];
    let t15;
    if ($[25] !== t13 || $[26] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": "page-comment-wrapper",
            ref: wrapperRef,
            className: t12
        }, t13, t14);
        $[25] = t13;
        $[26] = t14;
        $[27] = t15;
    } else t15 = $[27];
    return t15;
};
const $1f8c76250771e531$var$ViewPageFooterCommentsComponent = /*#__PURE__*/ (0, $42omo.memo)((t0)=>{
    const $ = (0, $frIzR.c)(36);
    const { contentId: contentId, classicComments: classicComments, loadingPriority: loadingPriority, hasReactions: hasReactions } = t0;
    const [state] = (0, $isEtk.useContentState)();
    let t1;
    if ($[0] !== contentId) {
        t1 = {
            contentId: contentId,
            offset: "",
            first: (0, $2i3To.DEFAULT_LIMIT)
        };
        $[0] = contentId;
        $[1] = t1;
    } else t1 = $[1];
    const t2 = hasReactions && window.__SSR_RENDERED__ && (0, $9wGTI.fg)("confluence_frontend_remove_comments_placeholder") ? "cache-first" : "cache-and-network";
    const t3 = !contentId;
    let t4;
    if ($[2] !== t1 || $[3] !== t2 || $[4] !== t3) {
        t4 = {
            variables: t1,
            fetchPolicy: t2,
            skip: t3
        };
        $[2] = t1;
        $[3] = t2;
        $[4] = t3;
        $[5] = t4;
    } else t4 = $[5];
    const { data: data, error: error } = (0, $j1Ss3.useQuery)(hasReactions ? (0, $ftXPY.CommentsSectionQuery) : (0, $ftXPY.CommentsSectionWithoutReactionsQuery), t4);
    if (error) (0, $7Sm4c.markErrorAsHandled)(error);
    let totalCount;
    if ($[6] !== data) {
        if (data?.comments && (0, $9wGTI.fg)("confluence_frontend_remove_comments_placeholder")) totalCount = data.comments.totalCount;
        $[6] = data;
        $[7] = totalCount;
    } else totalCount = $[7];
    const { getQueryParams: getQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t5;
    if ($[8] !== getQueryParams) {
        t5 = getQueryParams();
        $[8] = getQueryParams;
        $[9] = t5;
    } else t5 = $[9];
    const { focusedCommentId: focusedCommentId, replyToComment: replyToComment, showCommentArea: showCommentArea, editComment: editComment, commentId: commentId } = t5;
    const isFocusedComment = Boolean(focusedCommentId || replyToComment || showCommentArea || editComment === "true" && commentId);
    const [isCommentsReady, setIsCommentsReady] = (0, $42omo.useState)(false);
    let t6;
    if ($[10] !== contentId || $[11] !== experienceTracker || $[12] !== isFocusedComment) {
        t6 = ()=>{
            experienceTracker.start({
                name: (0, $irVI7.VIEW_PAGE_COMMENTS_EXPERIENCE),
                attributes: {
                    isConditionalRenderingOn: true,
                    isFocusedComment: isFocusedComment,
                    editor: "FABRIC",
                    contentId: contentId
                }
            });
        };
        $[10] = contentId;
        $[11] = experienceTracker;
        $[12] = isFocusedComment;
        $[13] = t6;
    } else t6 = $[13];
    const startExperienceTracker = t6;
    let t7;
    if ($[14] !== state.isContentReady || $[15] !== totalCount) {
        t7 = ()=>{
            if (totalCount === 0 && (0, $9wGTI.fg)("confluence_frontend_remove_comments_placeholder")) return null;
            const showPlaceholder = Boolean(undefined) || window.__SSR_RENDERED__ || state.isContentReady;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $deTj5.CommentPlaceholder), {
                showPlaceholder: showPlaceholder
            });
        };
        $[14] = state.isContentReady;
        $[15] = totalCount;
        $[16] = t7;
    } else t7 = $[16];
    totalCount;
    const renderCommentPlaceholder = t7;
    const t8 = !isFocusedComment;
    let t9;
    if ($[17] !== isCommentsReady || $[18] !== renderCommentPlaceholder) {
        t9 = !(0, $9wGTI.fg)("confluence_frontend_remove_comments_placeholder") && !isCommentsReady && renderCommentPlaceholder();
        $[17] = isCommentsReady;
        $[18] = renderCommentPlaceholder;
        $[19] = t9;
    } else t9 = $[19];
    let t10;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = ()=>setIsCommentsReady(true);
        $[20] = t10;
    } else t10 = $[20];
    const t11 = loadingPriority || (0, $398ES.LoadingPriority).PAINT;
    let t12;
    if ($[21] !== classicComments || $[22] !== contentId || $[23] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hrEV9.CommentsSectionLoader), {
            contentId: contentId,
            classicComments: classicComments,
            handlePageCommentsRender: t10,
            loadingPriority: t11
        });
        $[21] = classicComments;
        $[22] = contentId;
        $[23] = t11;
        $[24] = t12;
    } else t12 = $[24];
    let t13;
    if ($[25] !== t12 || $[26] !== t9) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, t9, t12);
        $[25] = t12;
        $[26] = t9;
        $[27] = t13;
    } else t13 = $[27];
    let t14;
    if ($[28] !== isCommentsReady || $[29] !== renderCommentPlaceholder || $[30] !== startExperienceTracker || $[31] !== state.isContentReady || $[32] !== t13 || $[33] !== t8 || $[34] !== totalCount) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1f8c76250771e531$var$LazyLoadablePageComments, {
            shouldLazyLoad: t8,
            isContentReady: state.isContentReady,
            renderPlaceholder: renderCommentPlaceholder,
            loadPageCommentsCallback: startExperienceTracker,
            isCommentsReady: isCommentsReady,
            totalCount: totalCount
        }, t13);
        $[28] = isCommentsReady;
        $[29] = renderCommentPlaceholder;
        $[30] = startExperienceTracker;
        $[31] = state.isContentReady;
        $[32] = t13;
        $[33] = t8;
        $[34] = totalCount;
        $[35] = t14;
    } else t14 = $[35];
    return t14;
});
const $1f8c76250771e531$export$3469ece96a08b09e = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).COLLABORATION
})($1f8c76250771e531$var$ViewPageFooterCommentsComponent);
























var $liGyh = parcelRequire("liGyh");


var $39nIX = parcelRequire("39nIX");


var $beAZw = parcelRequire("beAZw");


var $8uhVX = parcelRequire("8uhVX");


var $k5dl6 = parcelRequire("k5dl6");


var $3s9yq = parcelRequire("3s9yq");


var $e4o8D = parcelRequire("e4o8D");




const $9450efcd5fbf758a$export$9fdf0be90cc81aa6 = /*#__PURE__*/ (0, $42omo.memo)((t0)=>{
    const $ = (0, $frIzR.c)(33);
    const { contentId: contentId, loadingPriority: loadingPriority, isFabricPage: isFabricPage } = t0;
    const { editCommentId: editCommentId, replyToCommentId: replyToCommentId } = (0, $liGyh.useInlineCommentQueryParams)();
    const { getQueryParams: getQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    let t1;
    if ($[0] !== getQueryParams) {
        t1 = getQueryParams();
        $[0] = getQueryParams;
        $[1] = t1;
    } else t1 = $[1];
    const { focusedCommentId: queryParamsFocusedCommentId } = t1;
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const focusedCommentId = queryParamsFocusedCommentId ? queryParamsFocusedCommentId : undefined;
    let t2;
    if ($[2] !== contentId) {
        t2 = {
            pageId: contentId
        };
        $[2] = contentId;
        $[3] = t2;
    } else t2 = $[3];
    const t3 = !contentId || isFabricPage;
    let t4;
    if ($[4] !== t2 || $[5] !== t3) {
        t4 = {
            variables: t2,
            skip: t3
        };
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    const { error: error } = (0, $jMyy4.useQueryInterop)((0, $3s9yq.InlineCommentsQuery), t4);
    if (error) (0, $7Sm4c.markErrorAsHandled)(error);
    const t5 = focusedCommentId || "";
    const t6 = contentId || "";
    let t7;
    if ($[7] !== t5 || $[8] !== t6) {
        t7 = {
            commentId: t5,
            contentId: t6
        };
        $[7] = t5;
        $[8] = t6;
        $[9] = t7;
    } else t7 = $[9];
    const t8 = !(contentId && focusedCommentId);
    let t9;
    if ($[10] !== t7 || $[11] !== t8) {
        t9 = {
            variables: t7,
            fetchPolicy: "cache-first",
            skip: t8
        };
        $[10] = t7;
        $[11] = t8;
        $[12] = t9;
    } else t9 = $[12];
    const { data: data, error: focusedCommentError } = (0, $jMyy4.useQueryInterop)((0, $k5dl6.default), t9);
    if (focusedCommentError && (0, $1uFM6.isUnauthorizedError)(focusedCommentError)) (0, $7Sm4c.markErrorAsHandled)(focusedCommentError);
    const isFocusedInlineComment = Boolean(data?.comments?.nodes?.[0]?.isInlineComment);
    const { firstHighlightClicked: firstHighlightClicked, shouldDisplaySidebar: shouldDisplaySidebar } = (0, $9jl6v.useInlineCommentsContext)();
    const { toggleSidebar: toggleSidebar } = (0, $9jl6v.useInlineCommentsDispatchContext)();
    let t10;
    let t11;
    if ($[13] !== editCommentId || $[14] !== firstHighlightClicked || $[15] !== isFocusedInlineComment || $[16] !== replyToCommentId || $[17] !== shouldDisplaySidebar || $[18] !== toggleSidebar) {
        t10 = ()=>{
            if (window.__SSR_RENDERED__ && isFocusedInlineComment || isFocusedInlineComment || replyToCommentId || editCommentId && shouldDisplaySidebar || firstHighlightClicked && shouldDisplaySidebar) toggleSidebar(true);
        };
        t11 = [
            isFocusedInlineComment,
            replyToCommentId,
            editCommentId,
            firstHighlightClicked,
            toggleSidebar,
            shouldDisplaySidebar
        ];
        $[13] = editCommentId;
        $[14] = firstHighlightClicked;
        $[15] = isFocusedInlineComment;
        $[16] = replyToCommentId;
        $[17] = shouldDisplaySidebar;
        $[18] = toggleSidebar;
        $[19] = t10;
        $[20] = t11;
    } else {
        t10 = $[19];
        t11 = $[20];
    }
    (0, $42omo.useEffect)(t10, t11);
    if (renderServerPlaceholder && isFocusedInlineComment) {
        let t12;
        if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
            t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8uhVX.FocusedInlineComment), null);
            $[21] = t12;
        } else t12 = $[21];
        return t12;
    }
    let t12;
    if ($[22] !== renderServerPlaceholder) {
        t12 = renderServerPlaceholder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $beAZw.InlineCommentsLoadingSkeleton), null);
        $[22] = renderServerPlaceholder;
        $[23] = t12;
    } else t12 = $[23];
    let t13;
    if ($[24] !== contentId || $[25] !== focusedCommentId || $[26] !== isFabricPage || $[27] !== loadingPriority || $[28] !== shouldDisplaySidebar) {
        t13 = shouldDisplaySidebar && !isFabricPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $39nIX.InlineCommentsLoader), {
            pageId: contentId,
            isFabricPage: Boolean(isFabricPage),
            loadingPriority: loadingPriority || (0, $398ES.LoadingPriority).PAINT,
            focusedCommentId: focusedCommentId
        });
        $[24] = contentId;
        $[25] = focusedCommentId;
        $[26] = isFabricPage;
        $[27] = loadingPriority;
        $[28] = shouldDisplaySidebar;
        $[29] = t13;
    } else t13 = $[29];
    let t14;
    if ($[30] !== t12 || $[31] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, t12, t13);
        $[30] = t12;
        $[31] = t13;
        $[32] = t14;
    } else t14 = $[32];
    return t14;
});


















var $ke5Nx = parcelRequire("ke5Nx");





var $bFPHx = parcelRequire("bFPHx");










// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $36f4246476d285d5$var$ViewPageReactionsContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1yt4r2fv _1reoewfl _18m9ewfl _19pkn7od _2hwxn7od _otyrn7od _18u0n7od _n7zlia51 _1e0c1txw _4cvr1y6m _1bah1yb4 _11rm1hrf _1bsb1osq _p12fn7od _1p4q1ssb _1l0tx19p _3u9vusic _1aor1o8l",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $36f4246476d285d5$export$b2a33efe33addcf5 = (t0)=>{
    const $ = (0, $frIzR.c)(18);
    const { hasReactions: hasReactions, contentType: contentType, contentId: contentId, spaceId: spaceId, contentSubType: contentSubType } = t0;
    const [state] = (0, $isEtk.useContentState)();
    const { focusedPageReactionsId: focusedPageReactionsId } = (0, $ke5Nx.useReactionsQueryParams)();
    const { isReactionsEnabled: isReactionsEnabled } = (0, $42omo.useContext)((0, $8SCD6.ReactionsContext));
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    let t1;
    if ($[0] !== contentId || $[1] !== contentSubType || $[2] !== contentType || $[3] !== edition || $[4] !== focusedPageReactionsId || $[5] !== spaceId) {
        t1 = ()=>{
            if (contentType && spaceId) {
                const ReactionsLoader = Boolean(focusedPageReactionsId) ? (0, $1NF8X.ReactionsLoaderBackground) : (0, $1NF8X.ReactionsLoader);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ReactionsLoader, {
                    contentId: contentId,
                    location: contentType,
                    containerId: spaceId,
                    containerType: (0, $3FlVr.ReactionContainerType).SPACE,
                    contentSubType: contentSubType,
                    customAnalyticsAttributes: {
                        edition: edition,
                        reactionsPlacement: "bottom"
                    }
                });
            } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bFPHx.ReactionsPlaceholder), null);
        };
        $[0] = contentId;
        $[1] = contentSubType;
        $[2] = contentType;
        $[3] = edition;
        $[4] = focusedPageReactionsId;
        $[5] = spaceId;
        $[6] = t1;
    } else t1 = $[6];
    const displayReactions = t1;
    if (renderServerPlaceholder) {
        let t2;
        if ($[7] !== hasReactions || $[8] !== isReactionsEnabled) {
            t2 = isReactionsEnabled && hasReactions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bFPHx.ReactionsPlaceholder), {
                useAccuratePills: true
            });
            $[7] = hasReactions;
            $[8] = isReactionsEnabled;
            $[9] = t2;
        } else t2 = $[9];
        let t3;
        if ($[10] !== t2) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($36f4246476d285d5$var$ViewPageReactionsContainer, {
                id: "view-page-reactions-container",
                "data-vc": "view-page-reactions-container-server-placeholder",
                "data-testid": "view-page-reactions-container",
                "data-test-id": "view-page-reactions-container"
            }, t2);
            $[10] = t2;
            $[11] = t3;
        } else t3 = $[11];
        return t3;
    } else if (state?.isContentReady) {
        let t2;
        if ($[12] !== displayReactions || $[13] !== hasReactions || $[14] !== isReactionsEnabled) {
            t2 = hasReactions && isReactionsEnabled && displayReactions();
            $[12] = displayReactions;
            $[13] = hasReactions;
            $[14] = isReactionsEnabled;
            $[15] = t2;
        } else t2 = $[15];
        let t3;
        if ($[16] !== t2) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($36f4246476d285d5$var$ViewPageReactionsContainer, {
                id: "view-page-reactions-container",
                "data-vc": "view-page-reactions-container",
                "data-testid": "view-page-reactions-container",
                "data-test-id": "view-page-reactions-container"
            }, t2);
            $[16] = t2;
            $[17] = t3;
        } else t3 = $[17];
        return t3;
    }
    return null;
};









var $xQxzY = parcelRequire("xQxzY");


var $98zed = parcelRequire("98zed");

const $4d9db4017ca6ca1d$export$fb2757b0aa0b047e = (t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { contentId: contentId, cachedSubType: cachedSubType, cachedIsArchived: cachedIsArchived, renderLivePageAsViewPage: renderLivePageAsViewPage } = t0;
    const { isLive: isLive, isTypeKnown: isTypeKnown } = (0, $98zed.useIsLivePageWithSSR)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $eSUdr.default)`query useRenderLivePageEarlyContentSubTypeAndStatusQuery($contentId:ID!$versionOverride:Int){content(id:$contentId version:$versionOverride){nodes{id status subType}}}`;
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== contentId) {
        t2 = {
            contentId: contentId
        };
        $[1] = contentId;
        $[2] = t2;
    } else t2 = $[2];
    const t3 = isTypeKnown || !(!renderLivePageAsViewPage && cachedSubType === "live");
    let t4;
    if ($[3] !== t2 || $[4] !== t3) {
        t4 = {
            variables: t2,
            skip: t3,
            fetchPolicy: "network-only"
        };
        $[3] = t2;
        $[4] = t3;
        $[5] = t4;
    } else t4 = $[5];
    const { data: latestContentData, loading: isContentDataLoading } = (0, $xQxzY.useQuery)(t1, t4);
    if (isTypeKnown) {
        const t5 = Boolean(isLive);
        let t6;
        if ($[6] !== t5) {
            t6 = {
                renderLivePageEarly: t5,
                isLivePageCacheOutdated: false,
                isFastLoadedLivePageArchived: false,
                isLivePageFastLoadedFromSSR: true
            };
            $[6] = t5;
            $[7] = t6;
        } else t6 = $[7];
        return t6;
    }
    const loadedSubType = latestContentData?.content?.nodes?.[0]?.subType;
    const mostRecentSubType = isContentDataLoading ? cachedSubType : loadedSubType;
    const loadedIsArchived = latestContentData?.content?.nodes?.[0]?.status === "archived";
    const mostRecentIsArchived = isContentDataLoading ? cachedIsArchived : loadedIsArchived;
    const t5 = mostRecentSubType === "live" && !mostRecentIsArchived;
    const t6 = cachedSubType === "live" && !isContentDataLoading && (loadedSubType !== "live" || cachedIsArchived === false && loadedIsArchived === true);
    const t7 = mostRecentSubType === "live" && loadedIsArchived === true && !cachedIsArchived;
    let t8;
    if ($[8] !== t5 || $[9] !== t6 || $[10] !== t7) {
        t8 = {
            renderLivePageEarly: t5,
            isLivePageCacheOutdated: t6,
            isFastLoadedLivePageArchived: t7,
            isLivePageFastLoadedFromSSR: false
        };
        $[8] = t5;
        $[9] = t6;
        $[10] = t7;
        $[11] = t8;
    } else t8 = $[11];
    return t8;
};



var $6fTvc = parcelRequire("6fTvc");








var $T1bCI = parcelRequire("T1bCI");





var $hrAmX = parcelRequire("hrAmX");


var $jAfH5 = parcelRequire("jAfH5");







const $3993000b7971926b$export$d4da30e04f8ef8f8 = 'view-page-main-content-container';
const $3993000b7971926b$var$styles = {
    container: "_1e0cj4ch"
};
const $3993000b7971926b$export$1cbdd44a5a1781ff = (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { children: children, isFabricPage: isFabricPage } = t0;
    const { hasRecs: hasRecs } = (0, $jAfH5.usePageRecommendationData)();
    const setMinHeight = isFabricPage && !hasRecs && (0, $9wGTI.fg)("confluence_frontend_content_wrapper") && ((0, $9wGTI.fg)("confluence_frontend_unify_footer_comment_spacing") || (0, $6mKj3.expValEquals)("confluence_unify_footer_comments_space_width", "isEnabled", true));
    if (setMinHeight) {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = [
                (0, $hrAmX.BannerStateContainer)
            ];
            $[0] = t1;
        } else t1 = $[0];
        let t2;
        if ($[1] !== children) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                to: t1
            }, (bannerState)=>{
                const bannerHeight = bannerState.getTotalHeight();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                    xcss: $3993000b7971926b$var$styles.container,
                    style: {
                        minHeight: `calc(100vh - ${bannerHeight}px - ${46}px - ${64}px - ${14}px)`
                    },
                    testId: $3993000b7971926b$export$d4da30e04f8ef8f8,
                    "data-vc": $3993000b7971926b$export$d4da30e04f8ef8f8
                }, children);
            });
            $[1] = children;
            $[2] = t2;
        } else t2 = $[2];
        return t2;
    } else {
        let t1;
        if ($[3] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                testId: $3993000b7971926b$export$d4da30e04f8ef8f8,
                "data-vc": $3993000b7971926b$export$d4da30e04f8ef8f8
            }, children);
            $[3] = children;
            $[4] = t1;
        } else t1 = $[4];
        return t1;
    }
};









var $4u5NT = parcelRequire("4u5NT");


var $054Kg = parcelRequire("054Kg");




function $0035dfb85f61bd54$export$d43c540128020838(t0) {
    const $ = (0, $frIzR.c)(3);
    const { isFabricPage: isFabricPage } = t0;
    let t1;
    let t2;
    if ($[0] !== isFabricPage) {
        t1 = ()=>{
            if (!isFabricPage) {
                if ((0, $6mKj3.expValEquals)("cc_editor_ttvc_ft_split2", "isEnabled", true)) (0, $054Kg.updatePageloadName)("view-page-tiny");
                else (0, $4u5NT.updatePageLoadInteractionName)("view-page-tiny");
            }
        };
        t2 = [
            isFabricPage
        ];
        $[0] = isFabricPage;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(t1, t2);
    return null;
}


const $abc768867d8694f5$var$LivePageComponent = (0, $8tF9d.LivePageComponentLoader);
const $abc768867d8694f5$export$7c711af41fff7bc1 = (hasAllowedFeature)=>{
    if ((0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)() || (0, $lJlG6.isMobileApp_DO_NOT_USE)()) return hasAllowedFeature ? (0, $398ES.LoadingPriority).PAINT : (0, $398ES.LoadingPriority).LAZY;
    return null;
};
const $abc768867d8694f5$var$hideDuringPdfPrint = null;
const $abc768867d8694f5$var$FooterLoader = ()=>{
    const $ = (0, $frIzR.c)(2);
    if (!(0, $6mKj3.expVal)("cc_footer_loadable_fix", "isEnabled", false)) {
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8amSw.CustomHeaderFooterLoader), {
                type: (0, $8amSw.CUSTOM_HEADER_FOOTER_TYPES).FOOTER
            });
            $[0] = t0;
        } else t0 = $[0];
        return t0;
    }
    let t0;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $6mKj3.expVal)("cc_empty_loadable", "isEnabled", false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8amSw.CustomHeaderFooterLoader), {
            type: (0, $8amSw.CUSTOM_HEADER_FOOTER_TYPES).FOOTER
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8amSw.CustomFooterLoader), {
            type: (0, $8amSw.CUSTOM_HEADER_FOOTER_TYPES).FOOTER
        });
        $[1] = t0;
    } else t0 = $[1];
    return t0;
}; // NOTE: `contentId` represents the user's intended page but not always the displayed one. During transition to a new page, the component still renders the previous page until ViewPageContainer updates the contentQueryData.
const $abc768867d8694f5$export$77ec5b273f6febda = ({ spaceKey: spaceKey, contentId: contentId, contentHeader: contentHeader, contentScreenStyles: contentScreenStyles, classicComments: classicComments, eventHandlers: eventHandlers, titleAndByLineOptions: titleAndByLineOptions, hasByLine: hasByLine = true, hasPageComments: hasPageComments = true, hasSatisfactionSurveys: hasSatisfactionSurveys = true, hasInlineComments: hasInlineComments = true, hasInlineActions: hasInlineActions = true, hasLabels: hasLabels = true, hasReactions: hasReactions = true, hasEOPRecs: hasEOPRecs = true, hasQuickReload: hasQuickReload = true, hasProgressiveRendering: hasProgressiveRendering, appearance: appearance, children: children, setHasCoverPicture: setHasCoverPicture, isEmbeddedPage: isEmbeddedPage, ClassicEditorContextProviderLoader: ClassicEditorContextProviderLoader, renderLivePageAsViewPage: renderLivePageAsViewPage = false, cachedPageData: cachedPageData = {} })=>{
    const { locale: locale, isAIEarlyAccessEnabled: isAIEarlyAccessEnabled } = (0, $bQm3c.useSessionData)();
    const setContentLastModifiedTimestamp = (0, $hq2Sz.useSetContentLastModifiedTimestamp)();
    const { isLivePage: isLivePageOnSSR } = (0, $60cDW.getSSRRenderInputs)();
    const { resetInitialDataLoadedMap: resetInitialDataLoadedMap } = (0, $3mVfX.useCommentsPanelActions)();
    const { clearCommentsData: clearCommentsData } = (0, $8i27m.useCommentsDataActions)();
    const { clearProcessedData: clearProcessedData } = (0, $4L9ve.useProcessedCommentsDataActions)();
    const { clearMentionsFlags: clearMentionsFlags } = (0, $hdxAi.useMentionsNotificationsActions)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { isAIEnabledForContent: isAIEnabledForContent, isRovoEnabledForContent: isRovoEnabledForContent } = (0, $7mpOv.useIsAIEnabledForContent)({
        contentId: contentId
    });
    let { embeddedConfluenceSource: embeddedConfluenceSource } = (0, $iV5Ic.useReactProps_DO_NOT_USE)() || {};
    const { mode: contentMode } = (0, $gGHFp.useEditorContentModeValue)({
        contentId: contentId
    });
    if (!embeddedConfluenceSource && isEmbeddedPage) embeddedConfluenceSource = (0, $jiJCD.parse)(location.search, true).query.embeddedConfluenceSource?.toString();
    const isPdfExport = (0, $1NBp8.PDF_EXPORT_PAGE).match(window.location.pathname);
    const isReadingAidsAutoHighlightEnabled = (isAIEnabledForContent || isRovoEnabledForContent) && locale.startsWith('en'); // Setup for A/A experiment for testing stratified sampling with Statsig
    (0, $6mKj3.expVal)('cc_stratified_sampling_exp_aa', 'cohort', 'not-controlled');
    let stickyHeader = contentHeader;
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { setIsLive: setIsLive } = (0, $efvKr.useLivePageStoreActions)();
    const omnibarEligibility = (0, $586b596f3637df5c$export$a4a828fdcd26ce47)(isLivePage || !!isPdfExport);
    const [pageCommentsSectionRef, pageCommentsSectionInView] = (0, $iHQDd.useInView)();
    const [endOfPageRecRef, endOfPageRecInView] = (0, $iHQDd.useInView)();
    const { showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const { setActiveHighlight: setActiveHighlight } = (0, $9jl6v.useInlineCommentsDispatchContext)();
    const shouldShowBylineReactions = hasReactions && !isLivePage && (0, $9wGTI.fg)('cc_page_experiences_new_editor_byline');
    const setLivePageGlobalState = (0, $42omo.useCallback)((isContentLive)=>{
        setIsLive(isContentLive);
        (0, $78QFu.setIsLivePage)(isContentLive); // page load state used for analytics context (e.g. for experience tracking)
    }, [
        setIsLive
    ]);
    (0, $4d7d073c1c91ca91$export$7ac5f7e6449ca924)({
        skip: !(0, $9wGTI.fg)('cc_engagement_amplitude_session_replay_gate')
    });
    (0, $bd6002357c1db080$export$d42c6c42be666145)({
        contentId: contentId,
        skip: !(0, $9wGTI.fg)('cc-engagement-getting-started-nth-user-gate')
    });
    (0, $42omo.useEffect)(()=>{
        if (!isLivePage) return; // no cleanup needed
        // This is the cleanup function that runs when the component unmounts
        return ()=>{
            setLivePageGlobalState(false);
        };
    }, [
        isLivePage,
        setLivePageGlobalState
    ]); // Update view-page experience with `isLivePage` attribute to ensure all future experience fails denote whether it was on a live page
    (0, $42omo.useEffect)(()=>{
        const experienceState = experienceTracker.getExperienceState((0, $irVI7.VIEW_PAGE_EXPERIENCE));
        if (experienceState?.attributes?.contentId === contentId && experienceState?.attributes?.isLivePage !== isLivePage) experienceTracker.updateAttributes({
            name: (0, $irVI7.VIEW_PAGE_EXPERIENCE),
            attributes: {
                isLivePage: isLivePage
            }
        });
    }, [
        contentId,
        isLivePage,
        experienceTracker
    ]); // stickyHeader needs to be removed based on live page state since it's used in ViewPageContainer props
    if (isLivePage) stickyHeader = undefined;
    const { renderLivePageEarly: renderLivePageEarly, isLivePageCacheOutdated: isLivePageCacheOutdated, isFastLoadedLivePageArchived: isFastLoadedLivePageArchived, isLivePageFastLoadedFromSSR: isLivePageFastLoadedFromSSR } = (0, $4d9db4017ca6ca1d$export$fb2757b0aa0b047e)({
        contentId: contentId,
        cachedSubType: cachedPageData.subType,
        cachedIsArchived: cachedPageData.isArchived,
        renderLivePageAsViewPage: renderLivePageAsViewPage
    });
    (0, $42omo.useEffect)(()=>{
        if (renderLivePageEarly) setLivePageGlobalState(true);
    }, [
        renderLivePageEarly,
        setLivePageGlobalState
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            resetInitialDataLoadedMap();
            clearCommentsData();
            if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) clearProcessedData();
            clearMentionsFlags();
            setActiveHighlight(null);
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId
    ]);
    let livePageFastLoadedSource = '';
    if (renderLivePageEarly) {
        if (isLivePageFastLoadedFromSSR) livePageFastLoadedSource = 'SSR';
        else if (cachedPageData?.gqlType) livePageFastLoadedSource = `GQL:${cachedPageData.gqlType}`;
        else livePageFastLoadedSource = 'Unknown';
    }
    const { successfulExperiences: previousRouteSuccessfulExperiences } = (0, $fGzMp.getPreviousRouteExperienceData)();
    const livePagePerfData = (0, $42omo.useMemo)(()=>({
            renderLivePageEarly: renderLivePageEarly,
            isLivePageCacheOutdated: isLivePageCacheOutdated,
            isFastLoadedLivePageArchived: isFastLoadedLivePageArchived,
            isLivePageFastLoadedFromSSR: isLivePageFastLoadedFromSSR,
            livePageFastLoadedSource: livePageFastLoadedSource,
            contentExtensionMetrics: {},
            previousRouteSuccessfulExperiences: Array.from(previousRouteSuccessfulExperiences)
        }), [
        renderLivePageEarly,
        isLivePageCacheOutdated,
        isFastLoadedLivePageArchived,
        isLivePageFastLoadedFromSSR,
        livePageFastLoadedSource,
        previousRouteSuccessfulExperiences
    ]);
    const panelsModuleKeysAtlGeneral = (0, $juCeZ.useConnectAppsData)({
        contentId: contentId,
        location: (0, $eSLr0.ATL_GENERAL)
    });
    const panelsModuleKeysAtlFooter = (0, $juCeZ.useConnectAppsData)({
        contentId: contentId,
        location: (0, $eSLr0.ATL_FOOTER)
    });
    const customPerfData = {
        ...livePagePerfData,
        webPanelsAtlGeneral: panelsModuleKeysAtlGeneral,
        webPanelsAtlFooter: panelsModuleKeysAtlFooter,
        ...embeddedConfluenceSource ? {
            embeddedConfluenceSource: embeddedConfluenceSource
        } : {}
    };
    if ((0, $9wGTI.fg)('editor-ai-contentmode-performance-metric')) customPerfData['isContentModeDense'] = contentMode === 'compact';
    const { isAMN: isAMN, isLoading: isAMNPagePropertiesLoading, isRecurringParent: isRecurringParent, isLiveAMNPage: isLiveAMNPage } = (0, $iSXh4.useAutomatedMeetingNotesPageProperties)(contentId);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        // maintain analytics for AMN page views without triggering spotlight
        if (!isAMNPagePropertiesLoading && isAMN) createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'viewAMNPage',
                attributes: {
                    isLivePage: isLiveAMNPage,
                    isRecurringParent: isRecurringParent,
                    referralSource: (0, $iVU5h.getAMNReferralSourceFromQueryParam)()
                }
            }
        }).fire();
    }, [
        contentId,
        isAMN,
        isRecurringParent,
        isLiveAMNPage,
        isAMNPagePropertiesLoading,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jFm04.ContentOwnershipContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fNzRA.ObjectCommentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4r9Ir.NewCommentsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7IghX.PageCommentsCountProvider), {
        contentId: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a8ZQ3.DocumentUpdateStatusProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5pQ1Y.ContentRefetchProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8WQTF.RendererActionsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cZa7r.AnnotationsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cryCi.Provider), null, renderLivePageEarly ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2VZOl.NativeCollabPresenceStateContainer), {
        scope: contentId
    }, (0, $9wGTI.fg)('cc-engagement-nth-user-teammate-rollout-gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cfdf4590bc9d9b83$export$f9de7c50725ea941), {
        contentId: contentId,
        isLivePage: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($abc768867d8694f5$var$LivePageComponent, {
        contentId: contentId,
        spaceKey: spaceKey,
        ClassicEditorContextProviderLoader: ClassicEditorContextProviderLoader,
        customPerfData: customPerfData,
        loadingPriority: $abc768867d8694f5$export$7c711af41fff7bc1(true),
        isFastLoaded: true,
        hasByLineContributors: titleAndByLineOptions?.hasByLineContributors ?? true,
        hasByLineExtensions: titleAndByLineOptions?.hasByLineExtensions ?? true,
        hasReactions: hasReactions,
        hasPageComments: hasPageComments,
        hasInlineComments: hasInlineComments
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXika.ViewPageContainer), {
        spaceKey: spaceKey,
        contentId: contentId,
        stickyHeader: stickyHeader,
        contentScreenStyles: contentScreenStyles,
        customPerfData: customPerfData
    }, ({ isThemed: isThemed, contentQueryData: contentQueryData, contentQueryError: contentQueryError })=>{
        const contentStatus = contentQueryData?.content?.nodes?.[0]?.status;
        const contentType = contentQueryData?.content?.nodes?.[0]?.type;
        const contentSubType = contentQueryData?.content?.nodes?.[0]?.subType;
        const contentTitle = contentQueryData?.content?.nodes?.[0]?.title;
        const spaceId = contentQueryData?.content?.nodes?.[0]?.space?.id;
        const contentIdFromQuery = contentQueryData?.content?.nodes?.[0]?.id;
        const lastModifiedDate = contentQueryData?.content?.nodes?.[0]?.metadata?.lastModifiedDate;
        setContentLastModifiedTimestamp(lastModifiedDate);
        const pageWidthType = contentQueryData?.content?.nodes?.[0]?.appearancePublished?.nodes?.[0]?.value || `"default"`;
        const isFabricPage = Boolean(contentQueryData?.content?.nodes?.[0]?.body?.dynamic?.representation === 'atlas_doc_format');
        const hasLegacyContent = contentQueryData?.content?.nodes?.[0]?.body?.dynamic?.value?.includes('"extensionKey":"legacy-content"');
        const showAIButton = (contentType === 'page' || contentType === 'blogpost') && !isEmbeddedPage;
        const shouldShowEOPRecommendations = hasEOPRecs && (contentType === 'page' || contentType === 'blogpost') && !(isEmbeddedPage && (0, $6mKj3.isExperimentEnabled)('cc_page_experiences_native_embed_ui_updates'));
        const showAIButtonForTinyMCE = !isFabricPage && (0, $9wGTI.fg)('confluence_frontend_content_wrapper'); // getting info cover picture needs
        const { coverPicture: coverPicture, contentAppearance: contentAppearance, hasCoverPicture: hasCoverPicture, coverPictureWidth: coverPictureWidth } = (0, $3WPGR.getRendererCoverPictureInfo)(contentQueryData, false); // getting info for auto conversion
        const { queryDataId: queryDataId, editorProperty: editorProperty, isAutoConverted: isAutoConverted, fabricEditorSupported: fabricEditorSupported } = (0, $ayQVU.getAutoConvertionInfo)(contentQueryData?.content?.nodes?.[0]); // If live page is archived, we don't show LivePageComponent. Instead, archived live pages will render using the existing ViewPageContentRenderer.
        const isContentLive = isLivePageOnSSR || contentQueryData?.content?.nodes?.[0]?.subType === (0, $83sfO.LIVE_PAGE_SUBTYPE) && contentStatus !== 'archived';
        setLivePageGlobalState(isContentLive);
        if (isContentLive && !contentQueryError && !!contentIdFromQuery && !renderLivePageAsViewPage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2VZOl.NativeCollabPresenceStateContainer), {
            scope: contentId
        }, (0, $9wGTI.fg)('cc-engagement-nth-user-teammate-rollout-gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cfdf4590bc9d9b83$export$f9de7c50725ea941), {
            contentId: contentIdFromQuery,
            isLivePage: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($abc768867d8694f5$var$LivePageComponent, {
            contentId: contentIdFromQuery,
            spaceKey: spaceKey,
            ClassicEditorContextProviderLoader: ClassicEditorContextProviderLoader,
            customPerfData: customPerfData,
            isFastLoaded: false,
            hasByLineContributors: titleAndByLineOptions?.hasByLineContributors ?? true,
            hasByLineExtensions: titleAndByLineOptions?.hasByLineExtensions ?? true,
            hasReactions: hasReactions,
            hasPageComments: hasPageComments,
            hasInlineComments: hasInlineComments
        }));
        if (!!setHasCoverPicture) setHasCoverPicture(hasCoverPicture);
        const livePagePublishExperienceState = experienceTracker.getExperienceState((0, $irVI7.LIVE_PAGE_PUBLISH_EXPERIENCE));
        if (livePagePublishExperienceState && !livePagePublishExperienceState.hasStopped && livePagePublishExperienceState.attributes?.contentId === contentId) {
            // Succeed the live-page/publish and live-page-session experiences on render of view page content after conversion to page
            experienceTracker.succeed({
                name: (0, $irVI7.LIVE_PAGE_PUBLISH_EXPERIENCE)
            });
            experienceTracker.succeed({
                name: (0, $irVI7.LIVE_PAGE_SESSION_EXPERIENCE),
                attributes: {
                    convertedToPage: true
                }
            });
        }
        const importedContentSource = (0, $aK6zf.getImportSource)(contentQueryData);
        const importedContentDate = (0, $aK6zf.getImportDate)(contentQueryData);
        const isImportBannerShown = (0, $aK6zf.isImportBannerEnabled)(contentQueryData) && importedContentSource && importedContentDate;
        const maybeScrollToPageStart = Boolean(window.__SSR_RENDERED__) && (0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false) ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kJNMt.ScrollToPageStart), {
            key: `ScrollToPageStart-${contentId}`,
            isSmooth: false
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, maybeScrollToPageStart, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3993000b7971926b$export$1cbdd44a5a1781ff), {
            isFabricPage: isFabricPage
        }, isThemed && contentHeader, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0035dfb85f61bd54$export$d43c540128020838), {
            isFabricPage: isFabricPage
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8amSw.CustomHeaderFooterLoader), {
            type: (0, $8amSw.CUSTOM_HEADER_FOOTER_TYPES).HEADER
        }), isImportBannerShown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $99af38a0b1766526$export$f2bf6e79bf9b9470), {
            importSource: importedContentSource,
            importDate: importedContentDate,
            contentId: contentId
        }), hasCoverPicture && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3oWMY.RendererPageCoverPicture), {
            contentId: contentId,
            isPagePreview: false,
            coverPicture: coverPicture,
            contentAppearance: contentAppearance,
            isSpaceOverview: false,
            coverPictureWidthOverride: coverPictureWidth
        }), (0, $9wGTI.fg)('cc-engagement-nth-user-teammate-rollout-gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cfdf4590bc9d9b83$export$f9de7c50725ea941), {
            contentId: contentId,
            isLivePage: false
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6UMDm.AutoConversionByLineContextProvider), {
            editorProperty: editorProperty,
            fabricEditorSupported: fabricEditorSupported,
            isAutoConverted: !!isAutoConverted,
            queryDataId: queryDataId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8SCD6.ReactionsProvider), {
            contentId: contentId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dGhsu.ContentTitleWithByLine), {
            banner: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $deZfn.ArchivedPageBanner), {
                contentId: contentId
            }),
            contentId: contentId,
            spaceKey: spaceKey || '',
            hasCoverPicture: hasCoverPicture,
            pageWidthType: pageWidthType,
            isEmbeddedPage: isEmbeddedPage,
            shouldShowBylineReactions: shouldShowBylineReactions,
            contentType: contentType,
            contentSubType: contentSubType,
            spaceId: spaceId,
            ...titleAndByLineOptions,
            hasByLine: hasByLine
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6fTvc.ViewPageContent), {
            hasInlineComments: hasInlineComments,
            hasProgressiveRendering: hasProgressiveRendering,
            contentId: contentId,
            data: contentQueryData,
            error: contentQueryError,
            spaceKey: spaceKey,
            eventHandlerOverrides: eventHandlers,
            appearance: appearance,
            hasInlineActions: hasInlineActions,
            lastModifiedDate: lastModifiedDate || undefined,
            isEmbeddedPage: isEmbeddedPage,
            customPerfData: customPerfData,
            disableTableOverflowShadow: true
        }), (0, $9wGTI.fg)('cc-engagement-getting-started-nth-user-gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $627671e2381ceaa8$export$a4224605ab1026cb), {
            contentID: contentId,
            spaceKey: spaceKey
        }), hasInlineComments && (!isFabricPage || hasLegacyContent && !(0, $9wGTI.fg)('confluence_comment_disable_legacy_comment')) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4yKPM.InlineCommentsHighlighterLoader), {
            pageId: contentId
        }), isReadingAidsAutoHighlightEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6pBXK.ReadingAidsAcronymsHighlighter), {
            contentId: contentId
        }), hasLabels && (isFabricPage && (0, $9wGTI.fg)('confluence_frontend_labels_in_footer') ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kZEms.ViewPageLabelsLoader), {
            pageWidthType: pageWidthType,
            contentId: contentId,
            contentType: contentType,
            spaceKey: spaceKey,
            spaceId: spaceId,
            contentSubType: contentSubType
        })), shouldShowEOPRecommendations && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            ref: endOfPageRecRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fIKxq.EndOfPageRecommendationFinalLoader), {
            entityType: contentType || '',
            entityId: contentId,
            spaceKey: spaceKey || '',
            pageWidthType: pageWidthType
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fyPYm.ContentViewedEvent), {
            contentId: contentId
        }), (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hd53J.CommentsDataBackgroundLoader), {
            contentId: contentId
        })), isFabricPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                (0, $6mKj3.expValEquals)('afm-hide-elements-from-pdf-print', 'isEnabled', true) && "_24zuglyw"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lrMxq.ObjectSidebarControl), {
            hasCommentsButton: true,
            hasDetailsButton: true,
            hasLoomButton: contentStatus !== 'archived',
            hasAiButton: showAIButton,
            contentId: contentId,
            spaceKey: spaceKey,
            contentType: contentType,
            contentTitle: contentTitle,
            lastModifiedDate: lastModifiedDate,
            pageCommentsSectionInView: pageCommentsSectionInView,
            hasAudioButton: isAIEnabledForContent && (!(0, $6mKj3.isExperimentEnabled)('confluence_audio_labs_lozenge') || isAIEarlyAccessEnabled)
        })), hasReactions && !(0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? /* Disable unsupported reactions when rendering live page as view page */ !isLivePage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8SCD6.ReactionsProvider), {
            contentId: contentId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $36f4246476d285d5$export$b2a33efe33addcf5), {
            hasReactions: hasReactions,
            contentId: contentId,
            contentType: contentType,
            spaceId: spaceId,
            contentSubType: contentSubType
        })) : !(isPdfExport || (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) && // Hide divider if pdf export or new footer comment style (which has its own divider)
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f7fdcf7379ee3b47$export$2e0a83ec2e27ecbb), {
            testId: "reaction-placeholder-divider"
        })), !isLivePage && !isPdfExport && !pageCommentsSectionInView && !endOfPageRecInView && omnibarEligibility.showReactions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $be5272beb8fc0b67$export$e7639907c46a9b3c), {
            value: omnibarEligibility
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8SCD6.ReactionsProvider), {
            contentId: contentId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $695c4789ab8d8ace$export$621326c554b583ec), null))), hasPageComments && /* Disable unsupported page comments when rendering live page as view page */ !isLivePage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, (0, $9wGTI.fg)('confluence_comment_sticky_footer_enabled') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2xS8W.StickyDraftCommentContainer), {
            pageWidthType: pageWidthType,
            key: `StickyDraftCommentContainer-${contentId}`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lxDfD.default), {
            name: "renderer-footer-comments"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            ref: pageCommentsSectionRef,
            "data-vc": "footer-comments"
        }, !(0, $9wGTI.fg)('confluence_frontend_content_wrapper') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1f8c76250771e531$export$3469ece96a08b09e), {
            key: contentId,
            contentId: contentId,
            loadingPriority: (0, $9wGTI.fg)('confluence_frontend_remove_comments_placeholder') ? (0, $398ES.LoadingPriority).PAINT : $abc768867d8694f5$export$7c711af41fff7bc1(hasPageComments),
            classicComments: classicComments,
            hasReactions: hasReactions
        }), (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $70pcM.ObjectCommentWrapper), {
            showGeneralComment: true,
            showLabels: Boolean(hasLabels) && isFabricPage,
            pageWidthType: pageWidthType,
            loadingPriority: (0, $9wGTI.fg)('confluence_frontend_ssr_empty_footer_comments') ? (0, $398ES.LoadingPriority).PAINT : undefined,
            key: `ObjectCommentWrapper-${contentId}`,
            hasReactions: hasReactions
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dJ5r4.ViewCommentShortcutListener), {
            isFabricPage: isFabricPage,
            contentId: contentId
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($abc768867d8694f5$var$FooterLoader, null), isFabricPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iNYtG.PageCommentsPubSubHandler), {
            contentId: contentId,
            contentType: contentType
        }), hasQuickReload && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jXhAV.QuickReload), {
            contentId: contentId,
            contentType: contentType,
            // package on what a more correct lastPollTime value would be.
            lastPollTime: Date.now(),
            pageMode: (0, $fSC8h.PageMode).RENDERER,
            pageCommentsSectionInView: pageCommentsSectionInView,
            isFabricPage: isFabricPage,
            showCommentsPanel: showCommentsPanel
        }), hasSatisfactionSurveys && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $889eab36c217c00c$export$bdd4a5944172b352), {
            contentId: contentId,
            isEditorExpEnabled: (0, $9wGTI.fg)('cc_onboarding_experience')
        }), contentType === 'page' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cMKmt.LocalActivityViewPageTracker), {
            contentId: contentId
        }), children, hasInlineComments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9450efcd5fbf758a$export$9fdf0be90cc81aa6), {
            key: contentId,
            loadingPriority: $abc768867d8694f5$export$7c711af41fff7bc1(hasInlineComments),
            contentId: contentId,
            isFabricPage: isFabricPage
        }), contentType === 'page' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cmBjr.ConvertToLivePageFlag), null), (0, $6mKj3.expVal)('confluence_modernized_move_dialog', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lfmjq.MovePageSuccessFlag), null), showAIButton && showAIButtonForTinyMCE && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f23f475309e66803$export$9533f8bbe7f6f635), {
            spaceKey: spaceKey ?? '',
            contentId: contentId,
            contentType: contentType,
            lastModifiedDate: lastModifiedDate,
            pageCommentsSectionInView: pageCommentsSectionInView
        }));
    }))))))))))));
};
module.exports["ViewPageCommon"] = $abc768867d8694f5$export$77ec5b273f6febda;

});

parcelRegister("81QTc", function(module, exports) {

let $5d8771726149fb7c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5d8771726149fb7c$var$load("abyi8"),
    $5d8771726149fb7c$var$load("6wr18"),
    $5d8771726149fb7c$var$load("hsZkI"),
    $5d8771726149fb7c$var$load("i0ttV"),
    $5d8771726149fb7c$var$load("hOaAV"),
    $5d8771726149fb7c$var$load("iK6Gk"),
    $5d8771726149fb7c$var$load("cEqm7"),
    $5d8771726149fb7c$var$load("6XCf4"),
    $5d8771726149fb7c$var$load("5pvpJ"),
    $5d8771726149fb7c$var$load("ffEVr"),
    $5d8771726149fb7c$var$load("1qlDN"),
    $5d8771726149fb7c$var$load("1yVM6"),
    $5d8771726149fb7c$var$load("3tGwt")
]).then(()=>parcelRequire('6UCCJ'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("3ql08", function(module, exports) {

let $27e4172d2846d169$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $27e4172d2846d169$var$load("czC5b").then(()=>parcelRequire('d1GUC'));

});

parcelRegister("jGkfy", function(module, exports) {

let $e541a5c599a82f75$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e541a5c599a82f75$var$load("5W6cv").then(()=>parcelRequire('lCHNh'));

});

parcelRegister("8E6no", function(module, exports) {

let $64b7015f1975e8bc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $64b7015f1975e8bc$var$load("cJccL").then(()=>parcelRequire('ll9YW'));

});


//# sourceMappingURL=ViewPagePdfExportPage.c79a464d.js.map
